import { MailRecipientSelectorData, RequestProgressData, RouteEventData } from '@app/models';

export const GENERAL_MESSAGES = {
    WELCOME: 'Hey, Welcome!',
    SEARCH_NO_RESULT_HEAD: 'No Result',
    TIMEZONE_NOTE: 'Please note that all times and dates are shown in timezone: ',
    DASHBOARD: {
        DESC: 'Prior to comparing the data, make sure that you have selected the correct program, the time frame and the channel type. You can do so by clicking on dropdowns below.',
        ST: 'Track different activities in your organization. Our platform will provide data insights of member activated every month, successful vs failed communication through various channels, total broadcasts and survey each month.'
    },
    DUPLICATE_COM_MSG:
        'This is a courtesy alert that another communication/s for the date selected has either been sent or has been scheduled for sending.',
    TAG_SECTION: {
        title: 'Communication Tags',
        description: '',
        createBtnLabel: 'Add Tags',
        formData: {
            title: 'Communication Tags',
            description:
                'Tags are descriptive keywords you can add to your broadcast to help users find them again. These pieces of info help users to understand the need for sending a broadcast message. Note: You can add maximum of 5 tags per communication.',
            buttons: ['CLEAR ALL', 'CANCEL', 'DONE']
        },
        availableTags: [],
        values: [],
        tooltip: ''
    },
    TAG_MAX: 'Maximum number of tags selected',
    NO_TAGS_FOUND_TOOLTIP: 'No tags are available.',
    NO_TAGS_FOUND: 'There are no tags created or added for this communication.',
    NOT_FOUND_T: '404 Not Found',
    NOT_FOUND_ST: 'We could not find the requested page. Please verify the URL you are trying to access is correct.',
    MAINTENANCE_T: 'Under Maintenance',
    MAINTENANCE_ST: 'We are currently performing maintenance on our website. We will be back online shortly.',
    SERVICE_DOWN_NOTE:
        'Some of the feature(s) are unavailable for now. We are working hard to make them available for you again as soon as possible. Click on the button on the right to view the list of services that are unavailable.',
    SERVICE_DOWN_ST:
        "The service(s) listed below are under development. We appreciate your patience and will notify you when they're ready.",
    MOBILE_VERSION_MSG: 'You are viewing limited version of the site.',
    FREEMIUM_EXHAUST_WARN:
        "We're sorry, but you've reached your monthly limit for using this feature. Not to worry, though! You'll have access to this feature again on the first day of the upcoming month. If you have any questions, need assistance or if you are interested in unlocking the Premium features, don't hesitate to reach out to your dedicated account manager at Blooming Health. We're here to help!",
    MOBILE_FREEMIUM_EXHAUST_WARN:
        "You've reached your monthly limit for this feature. It'll be available again at the start of next month. Need help or interested in going Premium? Just give your Blooming Health account manager a shout. We're always here for you!",
    MOBILE_FREEMIUM_EXHAUST_PREVIEW_COMM_WARN:
        "You've reached your monthly limit for this feature. Need help or interested in going Premium? Just give your Blooming Health account manager a shout. We're always here for you!",
    TOS_PP_D1_TITLE: 'Welcome to Blooming Health',
    TOS_PP_D1_CNT_1: 'Please review and accept our terms to start using our services.By clicking "Accept," you agree to the following:',
    TOS_PP_D1_CNT_2: 'You have read our ',
    TOS_PP_D1_CNT_3: 'You consent to our use and updates of these terms.If you "Decline" you will be redirected back to the login page.',
    TOS_PP_D2_TITLE: 'Are you sure you want to decline?',
    TOS_PP_D2_CNT: 'If you choose to decline, you will need to sign in again to review the Terms & Conditions.',
    LANG_TRANSLATE_FAIL: 'Failed to load translation. Please try again by clicking refresh translation.',
    LANG_TRANSLATE_BODY_REQ: 'Sorry! Please enter a message to preview translation.',
    READ_MORE: 'READ MORE',
    READ_LESS: 'READ LESS',
    SCHEDULE_COMMUNICATION_WARNING:
        'You are scheduling this communication between 6 PM and 6 AM, which might not be ideal for your members. Are you sure you want to proceed?'
};
export const SETTINGS_MESSAGES = {
    DESC: 'Prior to accessing the application, please review the organization. Choose organization from the dropdown. You can even view the admin portal documents, terms of service and privacy policy by clicking on the links. To know more about Blooming Health, click on the link. To reach out to helpline, click on broadcast and survey helpline numbers to copy and dial.',
    ST: 'View and edit all the application-level settings. Our platform will help in creating surveys and automated event reminders, generating data driven insights and mass outreach utilities.',
    PAGE_ST: 'These changes apply to application level settings.',
    ORG_ST: 'Select the organization from the list you wish to access.',
    BROADCAST_HELPLINE_ST: 'To avail support, advice, information and guidance about broadcast, please contact this helpline number.',
    SURVEY_HELPLINE_ST: 'To avail support, advice, information and guidance about surveys, please contact this helpline number.',
    PORTAL_DOC_T: 'Admin Portal Documents',
    PORTAL_DOC_ST: 'Here are all the documents that are helpful for admin function.',
    LOGO_LINK: 'assets/images/BH_logo_1.png',
    BH_T: 'Blooming Health',
    BH_ST: 'Powering Healthy Aging-in-Place',
    ABOUT: 'To know more about Blooming Health',
    COPYRIGHT_T: 'Blooming Health Admin Portal',
    COPYRIGHT_ST: 'Copyright 2023 Blooming Health, Inc. All rights reserved.',
    GET_HELP_T: 'Get Help',
    GET_HELP_ST: 'Reach out to our support team'
};
/** VALIDATION HINTS WHICH ARE IN APPLICATION FORM FIELDS */
export const VALIDATIONS = {
    EMAIL: {
        REQUIRED: 'Enter a valid email address',
        INVALID: 'Enter valid email address'
    },
    PASSWORD: {
        REQUIRED: 'Enter a password',
        MINLENGTH: 'Password Length must be at least 10 character',
        INVALID: 'The password doesn’t match the format',
        MATCH: 'The password confirmation doesn’t match'
    },
    TOKEN: {
        EXPIRED: 'Token is expired or invalid. Try again.'
    }
};

/** HINT MESSAGES WHICH ARE PRESENT IN FORMS OF LOGIN MODULE */
export const FORM_MESSAGES = {
    ERROR_NOTIFICATION: 'Wrong username or password. Try again.',
    PASSWORD_HINT:
        'Hint: The password should be at least 10 characters long with one upper case letter, one lower case letter, one number and one symbol (e.g ! @ # $ % ^ & + = ).',
    ALTERNATE_PASSWORD_HINT:
        'Hint: Passwords must be different from last 3 passwords. The password should be at least 10 characters long with one upper case letter, one lower case letter, one number and one symbol (e.g ! @ # $ % ^ & + = ).',
    RESET_PWD:
        'To reset your password, please input your email address above and hit “Reset Password”. We’ll send you an email with instructions to follow.',
    PWD_REQUEST: 'Password reset request was sent successfully. A email message has been sent containing a link to reset the password.',
    RESET_SUCCESS: 'You have successfully reset the password for your account.',
    AC_PWD_SETUP_SUCCESS: 'You have successfully set up the password for your account.',
    AC_PWD_SETUP_INVALID: 'The link you’ve used has expired, is invalid, or has already been visited.',
    AC_PWD_SETUP_ERROR:
        "We weren't able to set up your account password at this moment. Please reach out to your organization administrator for more help or try again.",
    AC_DISABLED_SETUP_ERROR:
        "Your account has been locked out due to too many incorrect login attempts. Please click on 'Forgot password?' to unlock and reset it.",
    AC_DISABLED_NOTIFICATION: 'You have exceeded the maximum number of login attempts.',
    AC_DEACTIVATED_ERROR: "Your account has been deactivated by your organization's administrator. Please reach out to them directly to request reactivation.",
    AC_PASSWORD_EXPIRED: 'Your password has expired, please change it.',
    BROADCAST_ERROR: "We weren't able to broadcast your message at this moment. Try again."
};

export const BROADCAST_MESSAGES = {
    NO_MEMBER_FOUND:
        'We were not able to send your message since we could not find users who meet the send criteria. You can try another combination.',
    DISCARD_CHANGES: 'It looks like you have been editing something. If you leave before saving, your changes will be lost.',
    NO_TRANSLATION_WARN:
        'Since you did not add custom text to the selected language we will auto translate on your behalf. Click Cancel to change or Send to proceed.',
    TIMEZONE_NOTE: 'Please note that all times and dates are shown in timezone:   ',
    SEARCH_NO_RESULT_HEAD: 'No Result',
    SEARCH_NO_RESULT: "We couldn't find a Broadcast History that matches your search criteria. Please try again.",
    WELCOME: 'Hey, Welcome!',
    CREATE_NOTE: "Click the 'Create broadcast' above to get started.",
    HISTORYNOLIST: 'Broadcast history is empty. Please send a Broadcast/Welcome and check again.',
    HISTORY_LIST_DESC:
        'Prior to creating a new broadcast, please review the list below in order to copy the broadcast message. Click on down arrow to expand the broadcast message. If you wish to copy, click on copy message button and if you wish to refresh, click refresh for broadcasts that are in progress.',
    HISTORY_LIST_TIMEZONE:
        'View and track all the scheduled and completed broadcasts. Our platform will help manage the broadcast history. Please note that all times and dates are shown in time zone: ',
    NO_OTHER_LANGUAGE_FOUND: 'This organisation does not offer translation services for any other languages.',
    NO_SELECTED_INDIVIDUAL_USERS: 'Please begin by searching for the members you would like to add for Broadcast.',
    SEND_FORM: {
        SUBTITLE: 'To get started, fill some information about a broadcast message and the recipients.',
        NOTE_0: 'Send a real-time broadcast to members of your organization in different languages and across different available channels. This is useful to deliver timely announcements such as Weather Alerts, Center Openings, Event/Class Cancellations, Health Alerts etc.',
        NOTE_1: 'Please enter your message below in English, and choose how you would like to handle translations for the other member languages. By default, our service will use automatic translation from Amazon Cloud if you do not provide your own translation.',
        NOTE_2: 'Enter your message in English, translations for other languages will be handled automatically unless you provide your own. \nPersonalise your message by adding fields with “@” (e.g. @firstname, @lastname, @email, @phoneno, @caregiver_name, @caregiver_phoneno, @caregiver_email, @client_id, @member_ref)',
        ENGLISH_NOTE: 'Enter an English broadcast message, and all others will be translated automatically.',
        TRANSLATION_NOTE:
            'To customize your message for other languages, please turn off auto translate for the languages and add your message.',
        CHANNELS_NOTE: 'Members must have already chosen a channel in order to receive a message on that channel.',
        SCHEDULE_NOTE: 'Set date and time for future broadcast message.',
        PERSONALIZATION_NOTE: 'Note: Missing fields will be omitted from the final message.',
    },
    SCHEDULER_FORM: {
        SCH_SEARCH_NO_RESULT: "We couldn't find a Scheduled Broadcast that matches your search criteria. Please try again.",
        SCHEDULED_LIST_ST: 'Here you can send an immediate broadcast or schedule it for a future time.',
        SCHEDULED_LIST_NOTE:
            'Prior to creating a broadcast, please reference the already scheduled broadcasts below to ensure you are not creating a duplicate. Please click on an existing record to view/edit details about the scheduled broadcast. To delete the scheduled broadcast, please open the broadcast, click the ellipsis button [ ⋮ ] and then click delete.',
        SCHEDULER_WRONG_DATETIME: 'Enter a valid date and time. Datetime can not be in past.',
        RUN_WRONG_DATETIME: 'The date and time cannot be in the past. Please update it and try again.',
        RERUN_WRONG_DATETIME:
            'Please choose a date and time later than the initial run of this communication but not before the current time.',

        WELCOME_SCH_SEARCH_NO_RESULT: "We couldn't find a Scheduled Welcome Message that matches your search criteria. Please try again.",
        WELCOME_SCHEDULED_LIST_ST: 'Here you can send an immediate welcome message or schedule it for a future time.',
        WELCOME_SCHEDULED_LIST_NOTE:
            'Prior to creating a welcome message, please reference the already scheduled welcome messages below to ensure you are not creating a duplicate. Please click on an existing record to view/edit details about the scheduled welcome message. To delete the scheduled welcome message, please open the welcome message, click the ellipsis button [ ⋮ ] and then click delete.'
    },
    UPDATE_SUCESS: 'Broadcast updated successfully',
    SCH_NOT_FOUND_T: 'No scheduled broadcasts found.',
    WELCOME_SCH_NOT_FOUND_T: 'No scheduled welcome messages found.',
    SCH_NOT_FOUND_ST:
        "If you don't see the broadcast you scheduled, please ensure you have the right organization selected in the Settings page. If you would like to schedule a broadcast, please do so by clicking the Create Broadcast button on the top right of this page.",
    WELCOME_SCH_NOT_FOUND_ST:
        "If you don't see the welcome message you scheduled, please ensure you have the right organization selected in the Settings page. If you would like to schedule a welcome message, please do so by clicking the Create Welcome Message button on the top right of this page.",
    SCH_CREATE_NO_ELIGIBLE_WARN:
        'Please note that currently there are no eligible users to receive this broadcast but still you can schedule it.',
    SCH_DETAIL_NO_ELIGIBLE_WARN:
        'Please note that currently there are no eligible users to receive this broadcast. Kindly recheck the eligible users list.',
    SEND_NO_ELIGIBLE_ERR: 'Please note that currently there are no eligible users to receive this broadcast hence you cannot send it.',
    PREV_SHEET_ST:
        'Carefully review the final settings of your Broadcast run. When you ready, click the send button to execute the broadcast!',
    TAG_SECTION: {
        ...GENERAL_MESSAGES.TAG_SECTION,
        description:
            'Add a tag that helps to identify the message of this broadcast. Later you can easily search broadcasts in broadcast list using tags.',
        formData: {
            ...GENERAL_MESSAGES.TAG_SECTION.formData,
            description:
                'Tags are descriptive keywords you can add to your broadcast to help users find them again. These pieces of info help users to understand the need for sending a broadcast message. Note: You can add maximum of 5 tags per communication.'
        }
    },
    MULTI_SCH_DATA: {
        title: 'Schedule Re-run',
        createBtnLabel: 'CREATE RE-RUN',
        description: 'You can choose to schedule re-runs this broadcast by clicking the button to the right.',
        tableHeaderLabels: ['Scheduled On', 'Created By', 'Status', 'Delete Re-run'],
        tooltip:
            'Re-runs are only sent to recipients who have not already responded to a broadcast. We recommend setting up to 1-2 re-runs for optimal responses.',
        values: [],
        formData: {
            title: 'Create Schedule Re-run',
            description: 'Select date and time for the re-run of the broadcast. All times are in your local timezone [time_zone].',
            buttons: ['CANCEL', 'ADD'],
            labels: ['Send Date', 'Send Time']
        }
    },
    MULTI_SCH_DUPLICATE: "Scheduled re-run time and date shouldn't be the same as the other events.",
    SCH_DETAIL_MASTER_FAILED_ERR: 'Seems there were no eligible users to receive this broadcast hence the broadcast has been failed.',
    SCH_DETAIL_MASTER_ERROR:
        'It appears something went wrong with this broadcast. Please reach out to the Blooming Health administrator for more detail.',
    SCH_DETAIL_RERUN_FAILED_ERR:
        'It appears some rerun has failed due to no eligible users or something went wrong, Please reach out to the Blooming Health administrator for more detail.',
    INSTANT_RUN_WARN:
        'It appears that you have already Scheduled for reruns of this broadcast. If you want to send the broadcast immediately, please disable the Scheduled message button. Any scheduled messages and reruns will be removed once the broadcast is sent.',
    HISTORY_SENT_TO_COUNT_TOOLTIP: 'Click on the count to view the list of users that have received the broadcast message.',
    HISTORY_SENT_TO_DESC:
        'Below is the list of users who received this broadcast message. Please note that all times and dates are shown in the time zone: ',
    SUGGEST_ST:
        'Get an updated message recommendation, optimized for SMS, voice and email communication for older adults, powered by ChatGPT. If you like the results, please copy and paste it above in the box by clicking on copy icon.',
    SUGGEST_COPIED: 'Message recommendation copied',
    SENT_SUCCESS: 'Message has been sent successfully',
    MOBILE_MSG_ST: 'Send a real-time broadcast to members.',
    WELCOME_MOBILE_MSG_ST: 'Send a real-time welcome message to new members.',
    MOBILE_LANG_ST:
        "This message will be automatically translated into all languages supported by Blooming Health. If you'd like to personalize your translation, it's best to use a desktop or laptop for a smoother experience.",
    MOBILE_CHANNEL_ST: 'Members must have already chosen a channel in order to receive a message on that channel',
    MOBILE_FILTER_ST: 'Select a combination of filters for your broadcast audience',
    MOBILE_MASS_OUTREACH_ST: 'Select Audience, Interests etc.',
    MOBILE_OPTIONS_ST: 'Options for the filters, selected in the previous step',
    FREEMIUM_EXHAUST_WARN: GENERAL_MESSAGES.FREEMIUM_EXHAUST_WARN,
    MOBILE_FREEMIUM_EXHAUST_WARN: GENERAL_MESSAGES.MOBILE_FREEMIUM_EXHAUST_WARN,
    MOBILE_FREEMIUM_EXHAUST_PREVIEW_COMM_WARN: GENERAL_MESSAGES.MOBILE_FREEMIUM_EXHAUST_PREVIEW_COMM_WARN,
    FILE_ATTACHMENT: {
        VOICE_SELECTED_WARNING:
            'Attachments are not supported with the voice channel. To add an attachment, please disable the voice channel first.',
        ON_UPLOAD_WARNING:
            'Voice Calls do not support attachments. The voice channel has been disabled for this message. To use the voice channel, please create a new message without an attachment or remove the current attachment.',
        NOT_SUPPORTED:
            'File type not supported, please upload a valid file in one of the following formats: .gif, .jpeg, .png, .mp4, or .pdf',
        MAX_SIZE: 'The file uploaded exceeds the maximum file upload size limit.'
    }
};

export const BROADCAST_PROGRESS: RequestProgressData = {
    title: 'Processing Communications...',
    message:
        'We are sending your communications request! This may take a few minutes to complete depending on how many recipients you have selected. You can also leave this page to do other tasks, and the processing will continue in the background. You can visit the Broadcast History at any time to view the status of your request.',
    progressBarOptions: {
        color: 'accent',
        mode: 'indeterminate'
    }
};
export const BROADCAST_SCHEDULE: RequestProgressData = {
    title: 'Scheduling Broadcast...',
    message:
        'We are scheduling your communications request! This may take a few minutes to complete depending on how many recipients you have selected. You can also leave this page to do other tasks, and the processing will continue in the background. You can visit the Scheduled Broadcasts page at any time to view the status of your request.',
    progressBarOptions: {
        color: 'accent',
        mode: 'indeterminate'
    }
};

export const WELCOME_MESSAGE_SCHEDULE: RequestProgressData = {
    title: 'Scheduling Welcome Message...',
    message:
        'We are scheduling your communications request! This may take a few minutes to complete depending on how many recipients you have selected. You can also leave this page to do other tasks, and the processing will continue in the background. You can visit the Scheduled Welcome Messages page at any time to view the status of your request.',
    progressBarOptions: {
        color: 'accent',
        mode: 'indeterminate'
    }
};

export const BROADCAST_QUEUED: RequestProgressData = {
    title: 'Still Processing Communications...',
    message:
        'While your request has been successfully submitted, it is taking some time to complete. Please revisit the Broadcast History page in 10 minutes to view the status of your request. ',
    progressBarOptions: {
        color: 'warn',
        mode: 'determinate',
        value: 100
    }
};
export const SURVEY_PROGRESS: RequestProgressData = {
    title: 'Processing Communications...',
    message:
        'We are sending your communications request! This may take a few minutes to complete depending on how many recipients you have selected. You can also leave this page to do other tasks, and the processing will continue in the background. You can visit the Survey History at any time to view the status of your request.',
    progressBarOptions: {
        color: 'accent',
        mode: 'indeterminate'
    },
    actionLink: {
        label: 'View Survey History',
        link: '/home/survey/history'
    }
};
export const SURVEY_QUEUED: RequestProgressData = {
    title: 'Still Processing Communications...',
    message:
        'While your request has been successfully submitted, it is taking some time to complete. Please revisit the Survey History page in 10 minutes to view the status of your request. ',
    progressBarOptions: {
        color: 'warn',
        mode: 'determinate',
        value: 100
    },
    actionLink: {
        label: 'View Survey History',
        link: '/home/survey/history'
    }
};
export const SURVEY_SCHEDULE: RequestProgressData = {
    title: 'Scheduling Survey...',
    message:
        'We are scheduling your communications request! This may take a few minutes to complete depending on how many recipients you have selected. You can also leave this page to do other tasks, and the processing will continue in the background. You can visit the Scheduled Send Surveys page at any time to view the status of your request.',
    progressBarOptions: {
        color: 'accent',
        mode: 'indeterminate'
    },
    actionLink: {
        label: 'View scheduled survey',
        link: '/home/survey/scheduled'
    }
};
export const UPDATE_SURVEY_SCHEDULE: RequestProgressData = {
    title: 'Updating Scheduled Survey...',
    message:
        'We are scheduling your communications request! This may take a few minutes to complete depending on how many recipients you have selected. You can also leave this page to do other tasks, and the processing will continue in the background. You can visit the Send Survey page at any time to view the status of your request.',
    progressBarOptions: {
        color: 'accent',
        mode: 'indeterminate'
    },
    actionLink: {
        label: 'View scheduled survey',
        link: '/home/survey/scheduled'
    }
};

export const PROGRAM_MESSAGES = {
    WELCOME: GENERAL_MESSAGES.WELCOME,
    NORECORD: 'Click + to create a new event.',
    NORESULT: 'No Result',
    NORESULT_ST: "We couldn't find a event that matches your search criteria. Please try again.",
    ALERT_NOT_FOUND: 'No Alerts Found.',
    ALERT_NORESULT_ST: "We couldn't find a alert that matches your search criteria. Please try again.",
    SCHEDULE_ALERT_LIST:
        'Track reminders of different events . Our platform will help disable the reminders that may occur on a holiday. Click on the reminder and click disable button.',
    INSTRUCTIONS: {
        HEAD: 'You can manage all your events and schedules here. Please note the following definitions:',
        ACTIVE: 'If this is set to No, reminders for this event will not be sent out.',
        AUDIENCE:
            'By default, reminders will be sent to everyone in the organization. You can also choose to limit the audience to a particular Event.',
        EVENT_INFO: 'Add information about the event here, and any links if available (limit: 400 characters).',
        TYPE: 'Indicate if class is Virtual, In-person or Both',
        INSTREST: 'Only members who have the same category tagged will get these reminders.',
        SEND_ALERT: 'This is how many days before the event, the alert will be sent. Currently, this is 1 day before for all events.'
    },
    DELETE_CONFIRM: 'It looks like you want to delete a event from your organization. Are you sure?',
    REMINDER_CREATE_NOTE: 'By default the alert is set to 1 day before the event day.',
    SCHEDULE_CREATE_NOTE_1: 'Select event date and time and for the initial run of the event. All times are in your local time zone ',
    SCHEDULE_CREATE_NOTE_2: '. Choose Yes, if it is recurring and its recurrence period. Otherwise select No.',
    PROGRAM_SCHEDULE_CHANGE_NOTE:
        'Please note that if you make changes to any of the following fields, the scheduled alerts on the next tab will be recreated and you will lose any custom alerts that you have created. Fields: Recurring, Recurrence, Event Start Date, Event End Date, Send Alert.',
    LIST_ST:
        'Create and track events of different organizations. Our platform will help manage the events and schedule them for the chosen audience. Please note that all times and dates are shown in timezone: ',
    TIMEZONE_NOTE: GENERAL_MESSAGES.TIMEZONE_NOTE,
    DESC: 'Prior to creating a new event, please review the list below in order to avoid duplicates. Click on a row to view or edit the event. To delete or duplicate the event, click on it. Then click on the ellipsis button [ ⋮ ] on the top right corner and choose action.',
    ALERT_ST:
        'You can choose to create multiple reminders for this event by clicking the button to the bottom. By default, reminder is sent a day before. Maximum of 8 alerts can be created.',
    MAX_ALERT_WARN: 'Maximum of 8 alerts created.',
    ALERT_NOTE:
        'Same-day reminders are sent at 9:30am. All other reminders are sent at 11:30am for voice calls, and 12pm for SMS and emails.',
    HISTORY_ST:
        'View and track all the event reminders. Our platform will help manage the event reminders history. Please note that all times and dates are shown in time zone:',
    HISTORY_DESC: 'View and track the history of the event reminders.',
    HISTORY_NO_RESULT: 'Sorry, Event Reminders history is empty.',
    PROGRAM_DETAILS_DESC: 'Below is the information about the reminder.',
    FAILED_TO_LOAD: 'Failed to load data.',
    REFRESH_PAGE: 'Please refresh the page.'
};


export const WORKFLOW_MESAGES = {
    LIST_T: 'Workflow Automations',
    LIST_ST: 'Create and automate workflows tailored to your organization\'s needs. Our platform helps you design, manage, and execute workflows seamlessly, integrating Surveys, Broadcasts, update user profiles and Referrals. ', 
    ARCHIVED_LIST_T: 'Archived Workflows',
    ARCHIVED_LIST_ST: 'Access and manage your archived workflows with ease. Review past automation setups, including Surveys, Broadcasts, User Profile Updates, and Referrals. ', 
    TIMEZONE_NOTE: 'Please note that all times and dates are shown in timezone: ',
    SEARCH_NO_RESULT_HEAD: 'No Result',
    SEARCH_NO_RESULT: "We couldn't find a workflow that matches your search criteria. Please try again.",
    WELCOME: 'Hey, Welcome!',
    CREATE_NO_LIST: 'Click + to create a new workflow.',
    NO_SEND_SURVEY_TITLE: 'No workflow found.',
    LIST_DESC:"The Workflow Automation page helps you create, manage, and monitor automated workflows that trigger actions based on user activity or survey responses. Use this page to automate routine tasks like sending broadcasts, following up on surveys, or notifying caregivers—saving time and reducing manual effort. Before creating a new workflow, check the list below to avoid duplicates. Click on a workflow to view or edit it.",
    ARCHIVED_LIST_DESC : "This page contains archived workflows that were previously used to automate routine tasks like sending broadcasts, following up on surveys, or notifying caregivers. These are no longer active but can be referenced or restored if needed. Click on a workflow to view its details or reactivate it.",
    DELETE_CONFIRM : "You're about to delete this workflow and all its associated settings. This action cannot be undone. Are you sure you want to permanently delete this workflow?",
    INVALID_MQ_TRIGGER_MSG : "You picked a multi-question trigger option, but your survey has only one question. Please pick a different option.",
    CURRENT_VERSION_WARN: "You are viewing the latest version of this workflow. Please click on Version History to view and edit older versions from the list.",
    VERSION_WARN: "A newer version of this workflow is available. You can find it in the Version History section - marked with (Latest).",
    DELETE_VERSION_CONFIRM : "You're about to delete this workflow version and all its associated settings. This action cannot be undone. Are you sure you want to permanently delete this workflow version?",
    ACTIVATION_ERROR_MSG : "This workflow has an in-progress test. Cannot mark the workflow as active.",
    ACTIVATION_CONFIRM : "This workflow is currently in test mode. Activating it will end the test and make the workflow active for everyone. Do you want to continue with activation?",
    PUBLISH_CONFIRM : "This workflow is currently in test mode. Publishing it will end the test and make the workflow active for everyone. Do you want to continue with publishing?",
}

export const SURVEY_MESSAGES = {
    WELCOME: 'Hey, Welcome!',
    TIMEZONE_NOTE: 'Please note that all times and dates are shown in timezone:   ',
    INSTRUCTIONS: {
        HEAD: 'Create a survey to send to your member population. Typical use cases include social needs check-ins, wellness check-ins, satisfaction surveys, and member polls. Use the data from these surveys to better understand your older adult population and personalize the care you provide. ',
        SECONDHEAD: 'Please note the following definitions:',
        ACTIVE: 'If this is set to No, you will not be able to send this survey.',
        AUDIENCE:
            'Select who this survey is intended for. The current options include a specific program or the enter organization. Please be cautious when selecting the organization as when you execute it, it will go to everyone in your organization.',
        NAME: 'Select a friendly name to title your survey (members will not see this).',
        DESCRIPTION: 'Add a description for this survey so other admin staff know what/why it is about.'
    },
    CREATENOLIST: 'Click + to create a new survey.',
    DELETE_CONFIRM: 'It looks like you want to delete a survey instance from your organization. Are you sure?',
    SEARCH_NO_RESULT_HEAD: 'No Result',
    SEARCH_NO_RESULT: "We couldn't find a survey that matches your search criteria. Please try again.",
    DISCARD_CHANGES: 'It looks like you have been editing something. If you leave before saving, your changes will be lost.',
    LANGUAGE_NOTE: 'Save your survey first. It may take a few minutes for the translated versions to be available in other languages',
    CREATEEDIT: {
        NOQUESTION:
            'Right now there are no questions included in this survey. Please make sure to add a few questions to send the survey or run your survey.',
        NOLANGUAGE: 'Question page is not available as no language is added for this organization.',
        INACTIVE:
            'This survey is currently in an inactive state. Hence, it cannot be sent. To send this survey, please change the status to an active state.',
        EXECUTED:
            'This survey has already been sent earlier. It is now available for a rerun. You can only edit the status and description of this survey.',
        HAS_SCHEDULED_RUNS:
            'This survey is scheduled to be sent within the next 30 minutes. To make any changes, please cancel the current schedule and then edit the survey.',
        TRANSLATIONS_IN_PROGRESS:
            'We’re preparing your survey in all the languages enabled for your organization. This process may take a few minutes. You can navigate away and return to send the survey shortly.',
        QUESTIONS: {
            Q_INSTRUCTIONS: [
                '1. Introductory Message: Write a brief introduction. Example: "Hello, this is John from Hillside Program. We\'re conducting a short survey on our program(s). Please respond to each question with a number.',
                '2. Add a Question: Click the "Add Question" button and select the question type.',
                '3. Enter Your Question: Start by entering your question. For multiple-choice questions, click the "Add Option" button to add response options. For open-ended questions, no options are needed.',
                '4. Save and Create Next Question: Click "Add Question" to save the current question and create the next one.',
                '5. Repeat for Up to 30 Questions: Repeat steps 3 and 4 for up to 30 questions.',
                '6. Ending Message: Write a closing message. Example: "Thank you for completing our survey! Someone from our team will follow up with you shortly."',
                '7. Save and Submit: Click "Save" to save the entire survey.',
                '8. Exit and Review: You can now exit to the main survey menu and view your ready-to-be-sent survey in the survey list!',
                "Pro Tip: Consider working on Conditional Branching after adding all your questions. This way, you'll avoid the need to adjust it multiple times."
            ],
            HEADER: 'Please enter your question and multiple choice options represented by numbers. Keep in mind that this format needs to be optimized for SMS and Voice calls. For example:',
            MESSAGE: 'How many times a week do you speak to friends or loved ones?',
            MESSAGESUB1: 'Select 1 for none',
            MESSAGESUB2: 'Select 2 for 1-2 times / week',
            MESSAGESUB3: 'Select 3 for 3-4 times / week',
            MESSAGESUB4: 'Select 4 for 5+ times / week',
            Q_START: 'Introductory message',
            Q_END: 'Ending message',
            QUESTION_NOTE:
                'Before you begin, please note that you can conduct surveys via SMS and voice calls. When creating surveys, consider the language used, especially for voice calls, as questions will be read phonetically. Our system currently supports multiple-choice questions for both SMS and voice, as well as open-ended questions for both channels.',
            NOQUESTION:
                'Right now there are no questions included in this survey. Please make sure to add a few questions to send the survey or run your survey.',
            EXECUTED:
                'This survey has already been sent earlier. You cannot further edit or add any questions to this survey. You can either create a new survey or send it or you can rerun this survey from History & Rerun page.',
            WElCOME: {
                HEADER: 'Please enter your Introductory Message. Keep in mind that this format needs to be optimized for SMS and Voice calls. For example:',
                MESSAGE:
                    "Hi! We're reaching out on behalf of [Organization Name]. We're conducting a brief survey. Kindly answer the following questions by selecting the appropriate number on your phone keypad."
            },
            ENDING: {
                HEADER: 'Please enter your Ending Message. Keep in mind that this format needs to be optimized for SMS and Voice calls. For example:',
                MESSAGE:
                    'Thank you for your participation. We at the [Organization Name] will use this data to provide you with better services. We will be in touch. Have a nice day!'
            },
            ANSWERS: {
                HEADER: 'Please use numbers here to correspond to the appropriate choices in your question. Separate each choice with a comma. For example:',
                MESSAGE: '1, 2, 3, 4, 5',
                OPENENDEDWARN:
                    'If you select this option user can provide a free form response via SMS or Voice. You don’t need to fill out the acceptable choices in this case',
                NOTE: 'NOTE: Either choices or open Ended will be accepted.'
            },
            NO_CREATE_ACCESS: 'You can create questions only in English language.'
        },
        WORKFLOW_EXIST_WARNING:
            'Heads up! This survey is part of a workflow. If you edit the survey, it may change how the workflow works. After making changes, don’t forget to review and update the workflow too.'
    },
    EXECUTION: {
        NO_SEND_SURVEY_TITLE: 'No send survey found.',
        NO_FINAL_SAVE:
            'We are currently processing the questions in your survey. This may take a few minutes. Please try sending your survey again shortly.',
        NO_FINAL_SUBMIT:
            'Your survey has not been submitted yet. Please click the Submit button in the top right corner of the Questions Page to send your survey. The page can be accessed by clicking View Questions below.',
        SENDNOLIST:
            "If you don't see the survey you created, please ensure you have the right organization / program selected above. If you would like to send a survey, please add a survey from the Create Survey page and check again.",
        DETAIL_SEND_SURVEY: 'Members must have already Questions for different languages in order to receive a message',
        CHANNEL_SEND_SURVEY: 'Members must have already chosen a channel in order to receive a message on that channel',
        CONVERSATIONAL_AI_IMMEDIATE_ONLY: 'Conversational AI surveys for this organization are placed by the outbound calling agent on its own schedule, so they are sent immediately and cannot be scheduled or rerun.',
        FILTER_SEND_SURVEY:
            'Here you can select a combination of filters for your survey audience. Please double check to make sure the selections are as intended.',
        SEND_SURVEY:
            'Review the survey configurations and carefully select your audiences to send your survey out. Please note that if you do not have questions set up for a particular language then members who are set to that language will not receive the survey.',
        PREVIEW_SURVEY:
            'Carefully review the final settings of your survey run. When you ready, click the send button to execute the survey!',
        CONFIRMATION_SURVEY:
            'Congratulations! Your survey has been sent. Please see below for execution details. You can also access these details and Survey responses from the History & Rerun menu item in the navigation bar.',
        EXECUTED:
            'This survey has already been sent earlier. You can either create a new survey or send it or you can rerun this survey from History & Rerun page.',
        NOQUESTION:
            'Right now there are no questions included in this survey. Please make sure to add a few questions to send the survey or run your survey.',
        FILTER_WARN: "Since your organization doesn't appear to have a program, the survey cannot be submitted.",
        SCH_CARD_DESCRIPTION: 'Select date and time for the initial run of the survey. All times are in your local timezone ',
        MULTI_SCH_DATA: {
            title: 'Schedule Re-run',
            createBtnLabel: 'CREATE RE-RUN',
            description:
                'You can choose to schedule re-runs this survey by clicking the button to the right. You can also choose to schedule re-runs in order to solicit more responses.',
            tableHeaderLabels: ['Scheduled On', 'Created By', 'Status', 'Delete Rerun'],
            tooltip:
                'Re-runs are only sent to recipients who have not already responded to a survey. We recommend setting up to 1-2 re-runs for optimal responses.',
            values: [],
            formData: {
                title: 'Create Schedule Re-run',
                description: 'Select date and time for the re-run of the survey. All times are in your local timezone [time_zone].',
                buttons: ['CANCEL', 'ADD'],
                labels: ['Send Date', 'Send Time']
            }
        },
        MULTI_SCH_DUPLICATE: "Scheduled re-run time and date shouldn't be the same as the other events."
    },
    HISTORY_RERUN: {
        HISTORYNOLIST: 'Survey history is empty. Please send a survey and check again.',
        SURVEY_RUN_DETAIL:
            'Below is the information about the last time this survey instance was run. You can choose to re-run this survey instance: this will go out to the original audience members who have not yet responded to it. To send it to a brand new audience, please goto the Send Survey page. Here you can also download the latest responses for the instance from the link below.',
        PREVIEW_RERUN_SURVEY:
            'Review the survey configurations below to re-send this survey out to members who did not originally respond to the survey.',
        CONFIRMATION_RERUN_SURVEY: 'Congratulations! Your survey has been re-reun. Please see below for execution details.',
        INACTIVE:
            'This survey is currently inactive state. Therefore, it cannot be sent or run. To run this survey, please change it to an active state.',
        SURVEY_DELETED:
            'This survey which you want to see has already been deleted earlier. Therefore, you are unable to open and see the details of this survey.',
        SCHEDULED: 'This survey instance currently has re-runs scheduled for the future. Please review them prior to re-running again.',
        NO_RERUN_FOUND: 'Seems there were no instances of the survey being re-run.'
    },
    NO_SELECTED_INDIVIDUAL_USERS: 'Please begin by searching for the members you would like to add for Survey.',
    SCH_LIST_NOTE:
        'You can view all completed surveys & re-runs on Survey History & Rerun page and not in this page below. To view survey detail or the error encountered, click on the Survey. To check re-runs, click on the down arrow.',
    SCH_LIST_ST:
        'View and track all the details of scheduled surveys with their status. Click on the survey to get details. Please note that all times and dates are shown in time zone: ',
    SCH_DELETE_CONFIRM: 'It looks like you want to delete a scheduled survey instance from your organization. Are you sure?',
    SCH_NO_LIST_TITLE: 'No scheduled surveys found.',
    SCH_NO_LIST_DESC:
        "If you don't see the survey you scheduled, please ensure you have the right organization / program selected above. If you would like to schedule a survey, please do so from the Send Survey page.",
    PREV_SHEET_ST: 'Carefully review the final settings of your survey run. When you ready, click the send button to execute the survey!',
    LIST_DESC:
        'Prior to creating a new survey, please review the list below in order avoid duplicates. Click on a row to view or edit the survey. To delete, duplicate or send the survey, click on it. Then click on the ellipsis button [ ⋮ ] on the top right corner and choose action.',
    LIST_ST:
        'Create and track surveys of different organizations. Our platform will help manage the surveys and schedule them for the chosen audience.',
    SEND_LIST_DESC:
        'Prior to sending survey, please preview it. Click on a row to view or edit the survey. To schedule survey, click on it. Enter date and time and click schedule button.',
    SEND_LIST_ST: 'Our platform will help manage the surveys and schedule them for the chosen audience.',
    HISTORY_DESC:
        'To view or edit any the survey detail click on the survey. Click on the ellipsis button [ ⋮ ] and click on Survey detail and click save.',
    HISTORY_ST:
        'You can choose to re-run following survey instances. This will go out to the original audience members who have not yet responded to it. Please note that all times and dates are shown in timezone: ',
    SCH_CREATE_NO_ELIGIBLE_WARN:
        "Currently there are no eligible users to receive this survey. Please note that right now you can schedule but if no eligible users found during it's processing, it may fail.",
    SCH_DETAIL_NO_ELIGIBLE_WARN:
        'Please note that currently there are no eligible users to receive this survey. Kindly recheck the eligible users list.',
    SEND_NO_ELIGIBLE_ERR: 'Please note that currently there are no eligible users to receive this survey hence you cannot send it.',
    SCH_DETAIL_MASTER_FAILED_ERR:
        'It appears that there were no suitable users available to receive this survey. Hence, the survey has not been executed.',
    SCH_DETAIL_MASTER_ERROR:
        'It appears something went wrong with this survey. Please reach out to the Blooming Health administrator for more detail.',
    SCH_DETAIL_MASTER_CANCELED: 'This survey has been cancelled due to unsaved changes. Please save your changes and reschedule the survey',
    SCH_DETAIL_RERUN_FAILED_ERR:
        'It appears some rerun has failed due to no eligible users or something went wrong, Please reach out to the Blooming Health administrator for more detail.',
    TAG_SECTION: {
        ...GENERAL_MESSAGES.TAG_SECTION,
        description:
            'Add a tag that helps to identify the message of this survey. Later you can easily search surveys in survey list using tags.',
        formData: {
            ...GENERAL_MESSAGES.TAG_SECTION.formData,
            description:
                'Tags are descriptive keywords you can add to your survey to help users find them again. These pieces of info help users to understand the need for sending a survey. Note: You can add maximum of 5 tags per communication.'
        }
    },
    HISTORY_SENT_TO_COUNT_TOOLTIP: 'Click on the count to view the list of users that have received the survey.',
    HISTORY_SENT_TO_DESC:
        'Below is the list of users who received this Survey message. Please note that all times and dates are shown in the time zone: ',
    EMAIL_REQ_T: 'Want to get survey updates in your inbox?',
    EMAIL_REQ_ST:
        "Get survey updates and results directly to your inbox. Stay informed about your survey progress and see the results as soon as they're available.",
    EMAIL_RECIPIENTS_T: 'Share survey updates with team',
    EMAIL_RECIPIENTS_ST: 'Get your team in the loop on survey updates by adding them to the email list.',
    EMAIL_RECIPIENTS_INFO:
        'Your team will receive an email with the survey results as soon as they are available. The email will include a summary of the results, as well as links to the full results. You will also be able to download the results as a CSV file.',
    EMAIL_RECIPIENTS_FORM_T: 'Org Users',
    EMAIL_RECIPIENTS_FORM_ST: 'Get your team in the loop on survey updates by adding them to the email list.',
    NO_PORTAL_USERS_FOUND: 'No Recipients found to send email survey results.',
    MOBILE_FREEMIUM_EXHAUST_PREVIEW_COMM_WARN: GENERAL_MESSAGES.MOBILE_FREEMIUM_EXHAUST_PREVIEW_COMM_WARN,
    NO_USER_LABEL: 'No Users',
    NO_USER_LABEL_TOOLTIP: 'No Eligible Recipients',
    PDF_GENERATION_SUCCESS: 'Survey Visualization PDF has been Successfully Generated!'
};

export const SURVEY_CONDITIONAL_MESSAGES = {
    FETCH_SUCCESS: 'Survey questions fetched successfully',
    SAVE_SUCCESS: 'Survey questions saved successfully',
    SUBMIT_SUCCESS: 'You have successfully updated the survey information.',
    GO_NEXT_LABEL: 'Go to Next',
    GO_END_LABEL: 'Go to Ending Messsage',
    GO_QUESTION_LABEL: 'Go to Question ',
    RESET_WARN: 'This action will irreversibly reset all conditional branching configurations to accomodate the changes.',
    UNDO_WARN: 'This action will irreversibly reset all the changes.',
    DELETE_WARN: 'It looks like you want to delete a question from survey. Are you sure?',
    DISCARD_WARN: 'It looks like you have been editing something. If you leave before saving, your changes will be lost.',
    DISCARD_FINAL_SAVE_WARN:
        'You have unsaved changes on this page. Leaving without saving will result in the cancellation of any scheduled events using this survey. Would you like to save your changes before exiting?',
    CONFIRM_DIALOG_DATA: {
        title: 'WARNING',
        actions: { cancel: 'NO, CANCEL', ok: 'YES, PROCEED' },
        enableClose: true
    },
    NO_FINAL_SAVE_DIALOG_ACTIONS: { ok: 'EXIT WITHOUT SAVING', cancel: 'CANCEL' },
    OPEN_ENDED_LABEL: 'This is an open ended question',
    OPEN_ENDED_OPTION_LABEL: 'add an option',
    REORDER_PANEL_T: 'Move Question',
    REORDER_PANEL_ST: 'Use the drag icon next to each of the questions to re-arrange the order of the questions.',
    READ_MORE: GENERAL_MESSAGES.READ_MORE,
    READ_LESS: GENERAL_MESSAGES.READ_LESS,
    WELCOME_PLACEHOLDER:
        'Please enter your Introductory Message. Keep in mind that this format needs to be optimized for SMS and Voice calls',
    ENDING_PLACEHOLDER: 'Please enter your Ending Message. Keep in mind that this format needs to be optimized for SMS and Voice calls.',
    INTRO_MESSAGE_LABEL: 'Add Introductory Message',
    END_MESSAGE_LABEL: 'Add Ending Message'
};

export const SURVEY_MAIL_RECIPIENT_SELECTOR_DATA: MailRecipientSelectorData = {
    title: SURVEY_MESSAGES.EMAIL_RECIPIENTS_T,
    description: SURVEY_MESSAGES.EMAIL_RECIPIENTS_ST,
    tooltip: SURVEY_MESSAGES.EMAIL_RECIPIENTS_INFO,
    createBtnLabel: 'RECIPIENTS',
    formData: {
        title: SURVEY_MESSAGES.EMAIL_RECIPIENTS_FORM_T,
        description: SURVEY_MESSAGES.EMAIL_RECIPIENTS_FORM_ST,
        buttons: []
    },
    availableRecipients: [],
    values: [],
    warnNote: SURVEY_MESSAGES.NO_PORTAL_USERS_FOUND
};

export const USER_MESSAGES = {
    WARNINGS: {
        USER_UNSUBSCRIBED:
            'User needs to be resubscribed before they can start receiving messages. Please contact BH support to resubscribe and activate this user'
    }
};

export const PORTAL_USER_MESSAGES = {    
    SEARCH_NO_RESULT_HEAD: 'No Result',
    SEARCH_NO_RESULT: "We couldn't find a user that matches your search criteria. Please try again.",
    LIST_INFO:
        'You can create portal users or set up their individual profile here. Similarly, to see or update user profile information, please click on a record.',
    LIST_ST: 'Create and edit user details. You can manage the users and store their information.',
    NOT_FOUND_T: 'Hey, Welcome!',
    NOT_FOUND_ST: "Click the 'Create User' above to get started.",
    FORM_ST: 'Add a new portal user to your organization to help manage event messages and voice calls for older adults.',
    FORM_NOTE: 'Information needed in order to create a portal account.',
    USER_CREATED: 'Account setup is almost complete and the activation link has been sent to ',
    USER_UPDATE: 'Account update is complete for ',
    TERMS_POLICY: 'By continuing you agree to the Blooming Health ',
    CREATE_FORM_T: 'Create portal user',
    EDIT_FORM_T: 'Manage portal user',
    EDIT_FORM_ST: "User details for your organization's portal. Our platform helps you manage users and store their information securely.",
    RESEND_LINK_NOTE: 'The user has not yet set up the account. Would you like to send them a reminder email with the activation link?',
    RESEND_LINK_ACTION: 'RESEND ACTIVATION LINK',
    RESEND_LINK_ACTION_MSG: 'Activation link has been sent to the email. Please verify.',
    EDIT_SETTINGS_T: 'Settings',
    EDIT_SETTINGS_ST:
        'Edit the permissions of existing users to give them access to manage event messages and voice calls for older adults.',
    EDIT_USER_INFO_T: 'User Information',
    EDIT_USER_INFO_ST: 'Additional user information will enable communication between older adults and referral sources.',
    EDIT_FORM_TOOLTIP: 'You can manage portal users. You can edit the settings, user information and change security settings.',
    UNLOCK_RESET_PASSWORD: 'User account will be unlocked. Please check your email for password reset link.',
    RE_ACTIVATION_MESSAGE : "Are you certain you want to reactivate this user’s account? Once reactivated, they will regain access to Blooming Health.",
    RE_ACTIVATION_TITLE : "Re-activate this account?",
    DEACTIVATE_ACCOUNT_MESSAGE : "Are you certain you want to deactivate this user’s account? Once deactivated, they will lose access to Blooming Health.",
    DEACTIVATE_ACCOUNT_TITLE : "Are you sure you want to deactivate the user's account?",
    ROLE_UPDATE_MESSAGE : "Role will change from ",
    ROLE_UPDATE_TITLE : "Change user role?",
    USER_ACTIVATED_SUCCESSFULLY  : 'User activated successfully.',
    USER_DEACTIVATED_SUCCESSFULLY  : 'User deactivated successfully.'
};

export const GLOBAL_ERROR_MESSAGES = {
    NO_INTERNET: 'There is no internet connection. Try again.',
    REQUEST_TIMEOUT: 'The request timed out. Try again.',
    GENERIC_UNKNOWN_ERR_MSG: 'The application has encountered an unknown error. Please try again.',
    GENETIC_ERROR_TITLE: "That's an error.",
    REACH_OUT_US: 'If the problem persists. Please reach out to your organization administrator for more help.'
};

export const SNACKBAR_NOTIFICATION = {
    UNAUTHORIZED: 'Token has expired or invalid. Try again.',
    SIGNOUT: 'You have successfully logged out of your account',
    SIGNOUT_INACTIVITY: 'Token is expired or invalid. Try again.',
    SIGNIN: 'Signed in as ',
    ORGANIZATION_CHANGED_TO: 'Your current Organization has been changed to',
    CENTER_CHANGED_TO: 'Your current Program has been changed to',
    USER_ADDED: 'You have successfully added the user.',
    USER_UPDATED: 'You have successfully updated the user.',
    USER_WELCOME_SCHEDULE_MSG: 'Welcome messages will be sent automatically based on the schedule configured in Settings.',
    USER_NONDELETE: 'We cannot delete the user.',
    USER_DELETED: 'You have successfully deleted the user.',
    FORM_ERROR: 'Please fix the errors and try again.',
    CENTER_NOT_FOUND: 'It appears that your organisation does not have a program.',
    PROGRAM_ADDED: 'You have successfully created event information.',
    PROGRAM_UPDATED: 'You have successfully updated the event information.',
    PROGRAM_DELETED: 'You have successfully deleted the event information.',
    PROGRAM_DELETE_ERR: 'We cannot deleted the event at the moment.',
    SURVEY_ADDED: 'You have successfully created survey information.',
    SURVEY_UPDATED: 'You have successfully updated the survey information.',
    SCH_SURVEY_UPDATED: 'You have successfully updated the scheduled survey information.',
    SURVEY_DELETED: 'You have successfully deleted the survey information.',
    SCH_SURVEY_DELETED: 'You have successfully deleted the scheduled survey information.',
    SURVEY_DELETE_ERR: 'We cannot deleted the survey at the moment.',
    ERR_OCCCURED: 'Error occured, Try again.',
    SURVEY_Q_MAX: "You've reached maximum number of questions.",
    REMINDER_DATE_WRONG_FORMAT: 'Please input correct date format.',
    ORG_LANGUAGE_ERR: 'Oops, Something went wrong while fetching Organization languages. Please try again later.',
    ORG_NO_LANGUAGES_FOUND: 'There are no languages added to this organization.',
    INVALID_ORG_REPORT: 'Invalid Organization report. Please try again later.',
    DOWNLOAD_PROGRESS:
        'Download is in progress. Please do not refresh or navigate away from this page. This may take a few moments to complete.',
    SCHEDULER_UPDATED: 'You have successfully updated the scheduled broadcast information.',
    SCHEDULER_DELETED: 'You have successfully deleted the scheduled broadcast information.',
    WORKFLOW_UPDATED_TO : "Workflow ",
    VERSION_SET_AS_LATEST : "This version has been set as the latest successfully",
    VERSION_DELETED : "Workflow version deleted successfully",
};

export const SNACKBAR_ACTIONS = {
    OK: 'OK',
    SEND_WELCOMEMESSAGE: 'SEND A WELCOME MESSAGE',
    PROGRAM_ADD_ACTION: 'View Event Alert Schedule',
    SURVEY_ADD_ACTION: 'View Survey Information'
};

export const BULK_UPLOAD = {
    VALID_PROGRESS: 'Validation is in progress',
    UPLOAD_PROGRESS: 'Upload is in progress',
    FILE_TYPE_ERR: 'Selected file is not a correct CSV file',
    SNACKBAR_ERR: 'The file you uploaded has one or more errors. Please correct them and upload again',
    INLINE_ERR: 'Please fix errors and try again',
    ERROR: 'Invalid file uploaded. Please check the file and re-upload.',
    NO_PROGRAM_ERR:
        'There are no program options available in the current organization. Still you can proceed with the bulk upload. If you wish, you can add them later.',
    NO_INTEREST_ERR:
        'There are no interest options available in the current organization. Still you can proceed with the bulk upload. If you wish, you can add them later.',
    NO_INTEREST_NO_SENIOR_CENTER_ERR: 'There are no interest options available in the current organization.',
    NO_LANGUAGE_ERR: 'There are no language options available in the current organization. Please add and try again.',
    NO_SENIOR_CENTER_ERR: "Since your organization doesn't appear to have a program, bulk user upload cannot be done.",
    SNACKBAR_SUCCESS: 'You have successfully uploaded the user information',
    CONFIRM:
        'I, as an organization administrator certify that the above information is accurate to the best of my ability and the members has provided their consent to be enrolled into Blooming Health’s engagement service',
    AVOID_COMMON: {
        HEADER: 'Avoid common errors',
        BODY1_1: 'You can upload up to 5000 users per CSV file.',
        BODY1_2: 'Each user must have a unique email address.',
        BODY1_3: 'Household records allowed',
        BODY2: 'Users with duplicate phone numbers are not allowed in the sheet.',
        BODY4: "All parameters except Interests & Races/Ethnicity should not contain comma(',').",
        BODY5: 'Current Organisation have no valid interest to use in the sheet.',
        BODY5_1: 'Current Organisation interest are',
        BODY5_2: '. These are the valid interest to use in sheet.',
        BODY6_0: 'Current Organisation have no valid language(s)* to use in the sheet.',
        BODY6_1: 'Current Organisation languages are',
        BODY6_2: '. These are the valid languages to use in sheet.',
        BODY7_0: 'Current Organisation have no valid Race(s)* to use in the sheet.',
        BODY7_1: 'Current Organisation Races are',
        BODY7_2: '. These are the valid Races to use in sheet.',
        VALID_INTEREST: 'These are the acceptable interests to use in the document.',
        VALID_LANG: 'These are the acceptable languages to use in the document.',
        VALID_RACE: 'These are the acceptable races to use in the document.',
        VALID_PROGRAMS: 'These are the acceptable program(s) to use in the document.',
        VALID_GENDER: 'These are the acceptable genders to use in the document.',
        VALID_DISABILITY: 'These are the acceptable disability to use in the document.',
        VALID_VETERAN: 'These are the acceptable veteran to use in the document.',
        VALID_SNAP: 'These are the acceptable SNAP to use in the document.',
        INVALID_INTEREST: 'There are no interest options in the current organization.',
        INVALID_PROGRAMS: 'These are no program to use in the document.',
        INVALID_LANG: 'There are no language options in the current organization',
        INVALID_RACE: 'There are no race options in the current organization.'
    },
    PROCESS_CSV: {
        TITLE: 'Process CSV',
        BODY1: 'Come back later or stay on this page while we are processing the records.',
        BODY2: 'We will also send you an email once the processing completes.',
        IN_PROGRESS: 'Processing in Progress',
        COMPLETED: 'Process Completed',
        FAILED: 'Process Failed',
        ERROR_RECORDS_FOUND: ' invalid user records found.',
        ERROR_RECORDS_URL: 'Download this file to view erroneous records.',
        DUPLICATE_RECORDS_FOUND: ' Duplicate Records found.',
        DUPLICATE_RECORDS_FOUND_IN_DB: ' duplicate records found in database - Updated.',
        DUPLICATE_RECORDS_FOUND_IN_DB_NOT_UPDATED: ' Duplicate found in database',
        DUPLICATE_RECORDS_FOUND_IN_CSV: ' duplicate user records found in uploaded CSV file.',
        DUPLICATE_CYCLIC_RECORDS_FOUND_IN_CSV: ' duplicate/cyclic dependency records found in uploaded CSV file.',
        DUPLICATE_RECORDS_CSV_URL: ' Download this file to view duplicate records or records affected due to a cyclic dependency.',
        DUPLICATE_RECORDS_URL: ' Download this file to view duplicate records.',
        SUCCESS_RECORDS_FOUND: ' records processed successfully.',
        NOTE: 'Note: ',
        NUMBER_USERS_CREATED: ' new users created.',
        NEW_LABELS_ADDED: ' new labels have been added.',
        USER_LABELS_UPDATED: 'Labels have been updated for ',
        USERS: ' users.',
        FAIL_RECORDS_FOUND: 'Processing Failed',
        HOUSEHOLD_RECORDS_FOUND: ' users across the organization were found to be new household users after the upload.',
        CYCLIC_NUMBER_RECORDS: ' user records could not be processed due to errors.',
        CYCLIC_RECORDS_URL: ' Download this file to view error records.',
        TOTAL_RECORDS_FOUND: ' total user records found.',
        NUMBER_USERS_UPDATED: ' users updated.',
        VALID_RECORDS_FOUND: ' records were valid.',
        LABELS_ADDED: ' labels added to ',
        PROGRAMS_ADDED: ' programs added to ',
        INTERESTS_ADDED: ' interests added to ',
    },
    UPLOAD_CSV: {
        TITLE: 'NEW UPLOAD',
        HISTORY: 'HISTORY',
        INSTRUCTION_BODY1: 'Download and save one of the files below. Open the file in Excel or a similar app and add your user info.',
        SAMPLE_FILE: 'Download a blank file with the required headers',
        SAMPLE_FILE_DATA: 'Download a file that includes example user info',
        SENIOR_CENTERS: 'Senior Center(s)'
    },
    INSTRUCTION: {
        HEADER: 'Instructions',
        BODY: 'Download and save one of the files below. Open the file in Excel or a similar app and add your user info.',
        EXCEL_HEADER: 'Convert Excel to CSV',
        EXCEL_BODY1: 'In your Excel workbook, switch to the File tab, and then click Save As.',
        EXCEL_BODY2: 'In the Save as type box, choose to save your Excel file as CSV (Comma-separated Values).​',
        EXCEL_BODY3: 'Choose the destination folder where you want to save your Excel file in the CSV format, and then click Save.'
    },
    SAMPLE_FILE: 'Download a blank file with the required headers',
    SAMPLE_FILE_DATA: 'Download a file that includes example user info',
    CUSTOM_FILES_BUCKET_NAME: 'bulk_upload_sample_files',
    CUSTOM_FILES_PUBLIC_ACCESS_BASE_URL: 'https://storage.cloud.google.com/',
    BLANK_FILE_NAME: 'import_blank_users_without_snap_headers_13.0.xlsx',
    SAMPLE_FILE_NAME:
        'import_sample_users_without_snap_headers_13.0.xlsx',
    BLANK_SNAP_FILE_NAME:
        'import_blank_users_with_snap_headers_13.0.xlsx',
    SAMPLE_SNAP_FILE_NAME:
        'import_sample_users_with_snap_headers_13.0.xlsx',
    BLANK_MEDICAID_FILE_NAME:
        'import_blank_users_with_medicaid_headers_13.0.xlsx',
    SAMPLE_MEDICAID_FILE_NAME:
        'import_sample_users_with_medicaid_headers_13.0.0.xlsx',
    BLANK_MEDICAID_WITH_SNAP_FILE_NAME:
        'import_blank_users_with_medicaid_&snap_headers_13.0.xlsx',
    SAMPLE_MEDICAID_WITH_SNAP_FILE_NAME:
        'import_sample_users_with_medicaid_&snap_headers_13.0.xlsx',
    BLANK_FILE_LINK:
        'https://bloominghealthbucket.s3.us-east-2.amazonaws.com/bulkuploads/import_blank_users_without_snap_headers_13.0.xlsx',
    SAMPLE_FILE_LINK:
        'https://bloominghealthbucket.s3.us-east-2.amazonaws.com/bulkuploads/import_sample_users_without_snap_headers_13.0.xlsx',
    BLANK_SNAP_FILE_LINK:
        'https://bloominghealthbucket.s3.us-east-2.amazonaws.com/bulkuploads/import_blank_users_with_snap_headers_13.0.xlsx',
    SAMPLE_SNAP_FILE_LINK:
        'https://bloominghealthbucket.s3.us-east-2.amazonaws.com/bulkuploads/import_sample_users_with_snap_headers_13.0.xlsx',
    BLANK_MEDICAID_FILE_LINK:
        'https://bloominghealthbucket.s3.us-east-2.amazonaws.com/bulkuploads/import_blank_users_with_medicaid_headers_13.0.xlsx',
    SAMPLE_MEDICAID_FILE_LINK:
        'https://bloominghealthbucket.s3.us-east-2.amazonaws.com/bulkuploads/import_sample_users_with_medicaid_headers_13.0.0.xlsx',
    BLANK_MEDICAID_WITH_SNAP_FILE_LINK:
        'https://bloominghealthbucket.s3.us-east-2.amazonaws.com/bulkuploads/import_blank_users_with_medicaid_&snap_headers_13.0.xlsx',
    SAMPLE_MEDICAID_WITH_SNAP_FILE_LINK:
        'https://bloominghealthbucket.s3.us-east-2.amazonaws.com/bulkuploads/import_sample_users_with_medicaid_&snap_headers_13.0.xlsx',
    SCAN_FIELD_T: 'Do you want to scan for existing users?',
    SCAN_FIELD_ST: 'Automatically scan for existing users and upload new users.',
    DUP_PANEL_T: 'Manage duplicate users and households',
    DUP_PANEL_ST:
        'Eliminate duplicate users and households with our smart detection system. Keep your data clean and accurate with our duplicate management tools.',
    DUP_PANEL_ERROR_NOTE:
        'Our system has detected that some of the users you have uploaded are duplicates of existing users or are members of households that already exist in our system.',
    DUP_PANEL_ERROR_NOTE_1: "All users that were id'd as duplicates will be reconciled and their data will be combined/updated.",
    DUP_PANEL_ERROR_NOTE_2: "All users that were id'd as households will be created, mapped to partner profile, but left deactivated.",
    DUP_PANEL_ACTION_NOTE:
        'Click on the "Proceed" button to start the process. If you want to make changes to the upload sheet, you can click on the "Cancel" button to go back and make the necessary changes.',
    DUP_PANEL_UPLOAD_PROGRESS: 'The bulk user upload process will take a few minutes to finish.',
    FILE_UPLOAD: {
        LABEL: 'Header',
        MESSAGE: ' in the CSV file is not matching the format',
        VALUE: 'Header Error'
    }
};

export const USER_OPERATIONS = {
    DELETE_CONFIRM: 'It looks like you want to delete a user from your organization. Are you sure?',
    SEARCH_NO_RESULT_HEAD: 'No Result',
    SEARCH_NO_RESULT: "We couldn't find a user that matches your search criteria. Please try again.",
    WELCOME: 'Hey, Welcome!',
    CREATE_NOTE: "Click the 'Create User' above to get started.",
    USER_SELECTOR_NO_USERS: 'Please begin by searching for the member you would like to add for Broadcast message.',
    WELCOME_USER_SELECTOR_NO_USERS: 'Please begin by searching for the member you would like to add for Welcome message.',
    USER_LIST_NO_FILTER: 'Please begin by searching for the members you would like to edit/view their details.',
    USER_SELECTOR_NOTE: 'Inactive users cannot receive messages and hence cannot be selected.',
    WELCOME_USER_SELECTOR_NOTE: 'Active users cannot receive a welcome message and hence cannot be selected',
    USER_FORM_NOTE: "Get started by adding basic contact information about who you're adding as a member. * fields are mandatory.",
    ACTIVATION_NOTE: 'Settings for activating or unsubscribing a member.',
    MEDICAID_NOTE: 'Medicaid information of the user.',
    CONTACT_NOTE: 'Information needed in order to engage with a member.',
    DEMOGRAPHIC_NOTE: 'Additional member information will allow for insightful analysis and targeted communications',
    SNAP_NOTE: 'Additional attributes available for use with targeted SNAP benefit communications.',
    CUSTOM_FIELDS_NOTE: 'Additional information of the user, customized for the organization.',
    CAREGIVER_NOTE: "Information related to member's caregiver status.",
    AGE_FIELD_NOTE: 'Based on the date of birth field, the age is calculated.',
    LIST_INFO_NOTE:
        'You can upload/download users or set up their individual profile here. Similarly, to see or update user profile information, please click on a user record. To delete the user profile, please open the user, click the ellipsis button [ ⋮ ] and then click Delete.',
    LIST_DESC:
        'Create and edit user details of different organizations. Our platform will help manage the users and store their information. ',
    FILTER_DWN_WARN:
        'To download the user list based on your applied filters, please click Continue. If you would like to download the full user list please remove filters and try again.',
    NO_INTERESTS_WARN: 'It looks like you haven’t added any interests for this member yet. Would you like to add one now?'
};

/** Backend response messages for custom field APIs (centralized to avoid typos and simplify future changes). */
export const CUSTOM_FIELD_BACKEND_MESSAGES = {
    NO_CUSTOM_FIELDS_UPDATED: 'no custom fields updated'
};

export const REFERRAL_MESSAGES = {
    TIMEZONE_NOTE: GENERAL_MESSAGES.TIMEZONE_NOTE,
    LIST_ST:
        'Create and track referrals for your members that have needs to be addressed by another department or other organizations. Our platform will help manage the referral and track the outcomes. ',
    INCOMING_LIST_ST:
        'Track referrals for your members that have needs to be addressed by departments or organizations. Monitor referral outcomes and status updates. ',
    LIST_DELETE_NOTE:
        'Prior to creating a new referral, please review the list below in order to avoid duplicates. Click on a row to view or edit the referral. You can delete the referral if it is still in Draft status, by clicking on the ellipsis button [ ⋮ ] and choosing Delete.',
    NOT_FOUND: 'No Referral Found',
    SEARCH_NO_RESULT: "We couldn't find a referral that matches your search/filter criteria. Please try again.",
    CREATE_NOTE:
        'If you don\'t see the referral you created, please ensure you have the right organization / program selected above. If you would like to create a referral, click "Create referral" above to get started.',
    CREATE_MEMBER_SELECT_NOTE: 'Note: Inactive users cannot receive messages and hence cannot be selected.',
    INITIAL_PANEL_NOTE: 'Please begin by searching for the members you would like to add for Referral.',
    REGISTER_SUBTITLE:
        "To get started, fill out some basic information about who you're creating a referral for. (*) fields are mandatory.",
    CREATE_SUBTITLE: 'Select a matching provider and confirm the organization contact information for referral submission.',
    CREATE_NOTE_PLACEHOLDER:
        'Please provide detailed information about the member/s needs so the receiving provider can provide targeted help.',
    DETIAL_SUBTITLE: 'This referral has already been created. You can view or edit the referral details.',
    CREATE_CONSENT_DEFAULT: 'selected service provider',
    CREATE_CONSENT:
        'I confirm that the selected member/s have provided consent to have their needs and contact information shared with, and to be contacted by ',
    CREATE_CONSENT_ERROR: 'Please confirm consent to share information.',
    EMAIL_CONSENT_PREVIEW: 'I confirm the following statements regarding client consent of email: ',
    EMAIL_CONSENT_T_1:
        'The selected client has expressly consented to have limited protected health information (PHI) about the client delivered to ',
    EMAIL_CONSENT_T_2: " via Blooming Health's email feature, given the unsecured nature of information sent via email.",
    EMAIL_CONSENT_ST: 'In providing such consent, the client has acknowledged and understood that:',
    EMAIL_CONSENT_D_1:
        'Email communications can never be guaranteed to be completely secure and therefore, their PHI could be intercepted in transmission, misdirected, sent to an incorrect recipient, or accessed by unauthorized persons.',
    EMAIL_CONSENT_D_2: "Blooming Health will not be able to control who may open and view client's PHI at ",
    EMAIL_CONSENT_D_3_1: "Once client's PHI is shared with ",
    EMAIL_CONSENT_D_3_2: ' such PHI will be subject to ',
    EMAIL_CONSENT_D_3_3: "'s privacy policies.",
    EMAIL_CONSENT_READ_MORE: 'Read more',
    EMAIL_CONSENT_ERROR: 'Please confirm the statements regarding client consent of email.',
    FORM_SEC_0_T: 'Referral Status',
    FORM_SEC_0_ST: 'Each referral starts in Draft, and can be updated after it has been submitted.',
    FORM_SEC_1_T: 'Member Information',
    FORM_SEC_1_ST: 'Select a member for whom the referral will be created.',
    FORM_SEC_1_DISABLED_ST: 'Selected member details for whom the referral is created.',
    FORM_SEC_2_T: 'Need Information',
    FORM_SEC_2_ST: 'Select the category and need of this referral. Enter notes for further clarity.',
    FORM_SEC_2_DISABLED_ST: 'Selected category and need of this referral. Entered notes for further clarity.',
    FORM_SEC_3_T: 'Matching Service Providers',
    FORM_SEC_3_ST: 'Select a service provider available to your organization that can address the selected need.',
    FORM_SEC_3_DISABLED_ST: 'Selected service provider that can address the selected need for your organization.',
    FORM_SEC_4_T: 'Referring Organization Point of Contact',
    FORM_SEC_4_ST:
        'Review and/or update the default organization contact information that will be shared with the selected service provider in case they have questions about the referral.',
    FORM_SEC_4_DISABLED_ST:
        'The default organization contact information that will be shared with the selected service provider in case they have questions about the referral.',
    FORM_SEC_5_T: 'Submit Consent',
    FORM_SEC_5_ST: 'This is required for data sharing',
    FORM_SEC_6_T: 'Service Provider Point of Contact',
    FORM_SEC_6_ST: 'Contact details for service provider in case you have questions on the referral status.',
    FORM_ERR_MEMBERS: 'Member must be selected.',
    FORM_ERR_REFERRAL: 'All required(*) fields must be selected.',
    FORM_ERR_PROVIDER: "Service provider's service must be selected before submitting referral.",
    FORM_ERR_CONTACT: 'All required(*) fields must be entered before submitting referral.',
    FORM_NO_PROVIDER:
        "We couldn't find a service provider  that matches your selected category. Please change the category and check again.",
    REGISTER_SUCCESS: 'You have successfully registered a need.',
    SUBMIT_SUCCESS: 'The referral has been successfully submitted.',
    STATUS_UPT_SUCCESS: 'You have successfully updated the referral status.',
    STATUS_FORM_DESC:
        'You can change the status of the referral below based on any updates you have received from the referral organization or the referred member. Add notes for details on the status update. Please note: The status change is final and the referral becomes closed.',
    PRINT_INSTR:
        'A needs referral has been made on behalf of the person listed above. Please hold on to this document while your referral case is open. If you have any questions about the need or referral, please contact the agents mentioned above depending on the inquiry. You may receive a follow up communication in order to check if you have received the service satisfactorily.',
    EMAIL_AUTH: {
        WELCOME_T: 'Referral Management Solution',
        WELCOME_ST:
            "Welcome to Blooming Health's Referral Management Solution! You have been selected as a trusted partner for referrals. Please review the information and instructions carefully.",

        NEEDS_CONFIRM_ST:
            'Our platform will help manage the referral and track the outcomes. We would be grateful if you answer few of our questions.',
        NEEDS_CONFIRM_Q: 'Does your department address one or more of the following needs? ',

        FEEDBACK_PERSON_CONFIRM_ST: 'We would request few more details from you.',
        FEEDBACK_Q1: 'Are there any other needs your department provides that you would like to get referrals to?',
        FEEDBACK_Q2:
            'Please provide more information about the needs that you do not address, other needs you do address, and any criteria for the needs.',

        PERSON_CONFIRM_Q: 'Are you the right person in your department to receive referrals for these needs?',

        VERIFY_PERSON_T: 'Verify Department Contact Information ',
        VERIFY_PERSON_ST: "Please check your department's contact information to make sure it is up-to-date.",

        END_T: 'Thanks for sharing with us.',
        END_SUCCESS_ST: 'We will begin sending you with updates on referral needs that match your department services.',
        END_FORWARD_ST:
            'If you know the appropriate person from your department who would be able to fill out this information, please pass this email along to them. Thank you!',
        NEEDS_SHEET_T: 'Your department needs',
        NEEDS_SHEET_ST: "Please review the list of your department's needs and does your department provide any of the following services?",
        NO_NEEDS_FOUND: 'No needs found in your department to address'
    },
    EXT_REF_LIST_INFO:
        'Prior to creating a new referral, please review the list below in order to avoid duplicates. Click on a row to view or edit the referral. To print the referral list click on the ellipsis button [ ⋮ ] and choosing Print.',
    EXT_CMT_FORM_T: 'Referral Comment',
    EXT_CMT_FORM_ST: 'This is a discussion board, Users can give and receive feedback/comments.',
    EXT_REF_INFO_ST: 'Here are details of referral created. This includes category, status and notes.',
    EXT_REF_STAFF_INFO_ST: 'By default, the details of admin of the organization is shared here for reference.',
    EXT_REF_DISCUSSION_ST:
        'This is a discussion board. Users can give and receive feedback/comments. To add them, click the Add Comment button. To view all of them, click load more.',
    EXT_REF_TIMELINE_ST:
        'This is a chronological timeline of referral updates. It displays the status changes, user actions, and comments associated with the referral process. Each entry includes the status, user details, timestamp, and optional comments. Use the Load More button to view additional updates or comments as needed.'
};

export const MANAGE_INTERESTS = {
    title: 'Interests',
    subtitle:
        'You can add and edit interest categories for your organization here. Please be careful making changes as someone in your organization might be utilizing them for targeted messaging.',
    createBtn: 'ADD INTEREST',
    addRemoveUsers: 'EDIT USERS',
    saveChanges: 'SAVE',
    noRecordTitle: 'No Interests',
    noRecordSubTitle: 'No interests found in organization',
    noResultTitle: 'No Interests',
    noResultSubTitle: 'No interests found in organization',
    noUsersFoundTitle: 'No Users',
    noUsersFoundSubTitle: 'No users associated with this interest category',
    formSubtitle: 'Create a new interest for your organization. Enter the name of the interest and click on Add button.',
    createSuccess: 'You have successfully created an interest category. You can now assign to the users.',
    updateSuccess: 'You have successfully updated an interest category.',
    nameRequired: 'Enter an Interest Name',
    nameMaxlength: 'Must be at most 50 characters',
    associatedDialogTitle: 'Interest category associated with',
    associateError1: 'Failed to load data.',
    associateError2: 'Please close and re open the page.',
    associatedWarning:
        'This interest category is currently associated with organization members and program communications. Carefully review prior to making changes.',
    noWarnRecords1: 'Sorry, No ',
    noWarnRecords2: ' found for this interest category',
    INTEREST_USER_DRAWER_DESC: 'Below is the list of users for interest category: ',
    INTEREST_TIMEZONE_NOTE: 'Please note that all times and dates are shown in the time zone: ',
    USER_INTEREST_UPDATE_SUCCESS: 'You have successfully updated the users in this interest category.',
    ADD_REMOVE_USER_DRAWER_DESC:
        'Below is the list of users for this organization. Please note that all times and dates are shown in the time zone: ',
    ADD_REMOVE_USER_INSTRUCTIONS:
        'You may add or remove users by selecting or deselecting the checkbox associated with the user. Please be careful making changes as someone in your organization might be utilizing them for targeted messaging.',
    SORRY_NO_USERS: 'Sorry, No Users found.',
    MODIFY_FILTERS: 'Please modify your filters!',
    transferUsers: 'TRANSFER',
    editUsersSubtitle: 'Add or remove users by checking or unchecking from the list below. You can also transfer membership to other interests, programs or labels from this same menu.',
    transferInterestUsersSubtitle: 'Use this page to transfer selected interest category members to other labels, interest categories or programs. Tip: This page helps in moving selected members to the new label, interest category and programs.',
    transferDialogSelectMessage: 'Select a label, interest category or program.',
    addRemoveConfirmation: 'Add or remove users confirmation',
    transferSuccessMessage: 'Users transferred successfully'
};

export const MANAGE_LABELS = {
    title: 'Labels',
    subtitle:
        'You can add and activate or archive labels for your organization here. Please be careful making changes as someone in your organization might be utilizing them.',
    addLabelButton: 'ADD LABEL',
    addRemoveUsers: 'EDIT USERS',
    saveChanges: 'SAVE',
    noRecordTitle: 'No Labels',
    noRecordSubTitle: 'No Labels found in organization',
    noUsersFoundTitle: 'No Users',
    noUsersFoundSubTitle: 'No users associated with this label',
    formSubtitle: 'Create a new label for your organization. Enter the name of the label and click on Add button.',
    createSuccess: 'You have successfully created label. You can now assign to the users.',
    updateSuccess: 'You have successfully updated label.',
    nameRequired: 'Enter a label name',
    nameMaxlength: 'Must be at most 60 characters',
    associatedDialogTitle: 'Label associated with',
    associateError1: 'Failed to load data.',
    associateError2: 'Please close and re open the page.',
    associatedWarning:
        'This label is currently associated with organization members and program communications. Carefully review prior to making changes.',
    noWarnRecords1: 'Sorry, No ',
    noWarnRecords2: ' found for this label',
    transferUsers: 'TRANSFER',
    editUsersSubtitle: 'Add or remove users by checking or unchecking from the list below. You can also transfer membership to other labels, interest categories, or programs from this same menu.',
    LABEL_USER_DRAWER_DESC: 'Below is the list of users for label: ',
    LABEL_TIMEZONE_NOTE: 'Please note that all times and dates are shown in the time zone: ',
    USER_LABEL_UPDATE_SUCCESS: 'You have successfully updated the users in this label.',
    ADD_REMOVE_USER_DRAWER_DESC:
        'Below is the list of users for this organization. Please note that all times and dates are shown in the time zone: ',
    ADD_REMOVE_USER_INSTRUCTIONS:
        'You may add or remove users by selecting or deselecting the checkbox associated with the user. Please be careful making changes as someone in your organization might be utilizing them for targeted messaging.',
    SORRY_NO_USERS: 'Sorry, No Users found.',
    MODIFY_FILTERS: 'Please modify your filters!',
    LABELS_UPDATED_SUCCESSFULLY: 'Labels updated successfully',
    NO_SAFE_RECORDS_TO_UPDATE: 'No safe records to update',
    transferLabelUsersSubtitle: 'Use this page to transfer selected label members to other labels, interest categories or programs. Tip: This page helps in moving selected members to the new label, interest category and programs.',
    transferDialogSelectMessage: "Select a label, interest category or program.",
    addRemoveConfirmation: "Add or remove users confirmation",
    transferSuccessMessage: 'Users transferred successfully'
};

export const MANAGE_PROGRAMS = {
    title: 'Programs',
    subtitle: 
        'You can create, edit and manage programs for your organization here. Please be careful making changes as someone in your organization might be utilizing them.',
    createProgramBtn: 'CREATE PROGRAM',
    addRemoveUsers: 'EDIT USERS',
    addProgramTitle: 'Configure your program',
    editProgramTitle: 'Edit your program',
    addProgramSubtitle: 
        'Programs represent service units—like a Senior Center or Food Pantry—where your team connects with participants for specific services.',
    editUsersSubtitle: 'Add or remove the users by checking or unchecking from the below list. You can also transfer the membership to another programs, interest category or labels from this same menu.',
    noProgramdesc: 'This contains users that are not associated with any program',
    programDesc: 'Enter a name that represents your service unit. Must be unique.',
    transferUsersSubtitle: 'Use this page to transfer selected program members to other programs, interest categories or labels. Tip: This page helps in moving selected members to the new Program, interest category and labels.',
    orgIdDesc: 'This connects your program to your organization.',
    progLeadDesc: 'Person leading or coordinating this program.',
    phoneDesc: 'Used for inbound call routing and transfers.',
    emailDesc: 'Replies to outbound emails will go here.',
    timezoneDesc: 'Used for scheduling messages and reminders.',
    serviceTypeDesc: 'Select one or more service categories.',
    zipcodeDesc: "Defines the program's service area.",
    serviceSelector: {
        title: 'Service Types',
        description: 'Select the types of services this program provides',
        createBtnLabel: 'Add Service Types',
        formData: {
            title: 'Select Service Types',
            description: 'Search for existing service types or create new ones',
            buttons: ['CLEAR ALL', 'CANCEL', 'APPLY']
        }
    },
    noUsersFoundTitle: 'No Users',
    noUsersFoundSubTitle: 'No users associated with this program',
    validationMessages: {
        program_name: {
            required: 'Program name is required'
        },
        program_lead: {
            required: 'Program lead is required'
        },
        redirect_phone_number: {
            required: 'Phone number is required',
            pattern: 'Please enter a valid phone number'
        },
        reply_email: {
            email: 'Invalid email format'
        },
        timezone: {
            required: 'Timezone is required'
        },
        zip_code: {
            pattern: 'Please enter a valid zipcode',
            maxlength: 'Please enter a valid zipcode'
        }
    }
};

export const ACTIVATE_NEW_USERS = {
    title: 'Activate New Users',
    subtitle: 'Welcome new users automatically when they join your program.',
    welcomeMessage: {
        title: 'Welcome Message',
        description: 'A welcome message is the first touchpoint for your members. Keep it friendly, simple, and supportive. We\'ll automatically add the required opt-out information based on how the message is sent.',
        generateButton: 'Generate with AI',
        defaultPlaceholder: 'Hi @firstname, welcome to Blooming Health! We\'re glad you\'re here.'
    },
    channelPreviewDesc: 'This is how your message will appear in different channels with required opt-out language appended.',
    optOutMessages: {
        sms: 'To view more information about this service, text \'HELP\'. If you wish to opt out of this free service, text \'STOP\'. See Terms: gobh.us/terms & Privacy Policy: gobh.us/privacy. Msg&Data rates may apply.',
        voice: 'You can view our Terms of Use and Privacy Policy at gobh.us. If you would like to unsubscribe from this free service, please call back this number and select the appropriate menu options. Thanks and have a great day!',
        email: 'You can view our Terms of Use here: gobh.us/terms, and Privacy Policy here: gobh.us/privacy. If you wish to be removed from this free service, you can click on the unsubscribe link below.'
    },
    otherLanguages: {
        title: 'Other Languages',
        description: 'To customize your message for other languages, please turn off auto translate for the languages and add your message.',
        autoTranslateLabel: 'Auto Translate'
    }
};

export enum StatusCode {
    Successful = 200,
    Created = 201,
    Passwordreset = 307,
    Badrequest = 400,
    Unauthorized = 401,
    NotFound = 404,
    Forbidden = 403,
    ServerError = 500,
    GatewayTimeout = 504,
    Conflict = 409
}

export const ERROR_STRINGS = {
    TIMEOUT: 'TimeoutError',
    SEQUELIZE: 'Sequelize'
};

export const SURVEY_DETAIL_KEYS: { [k: string]: { [l: string]: string } } = {
    preview: {
        centers: 'Audience',
        org_labels: 'Organization Labels',
        member_ref: 'Audience',
        languages: 'Languages',
        channels: 'Channels',
        interests: 'Interests',
        snap: 'SNAP Benefits',
        caregiver: 'Care Givers',
        schedule_time: 'Schedule Date & Time',
        eligiblecount: 'Eligible Count'
    },
    confirm: {
        centers: 'Audience',
        org_labels: 'Organization Labels',
        member_ref: 'Audience',
        languages: 'Languages',
        channels: 'Channels',
        recipients: 'Recipients'
    },
    historyPreview: {
        run_date: 'First Run Date',
        centers: 'Audience',
        org_labels: 'Organization Labels',
        interest_summary: 'Interests',
        age: 'Age',
        disability: 'Disability Status',
        gender: 'Gender',
        languages: 'Language(s)',
        race: 'Race/Ethnicity',
        veteran: 'Veteran Status',
        zipcodes: 'Zip Code',
        member_ref: 'Audience',
        channels: 'Channels',
        eligiblecount: 'Last Run Eligible Count',
        responses: 'Total Respondents',
        original_run_by: 'First Run By',
        last_run_by: 'Last Run By',
        last_run_date: 'Last Run Date',
        status: 'Last Run Status',
    },
    rerunPreview: {
        centers: 'Audience',
        org_labels: 'Organization Labels',
        interest_summary: 'Interests',
        age: 'Age',
        disability: 'Disability Status',
        gender: 'Gender',
        race: 'Race/Ethnicity',
        veteran: 'Veteran Status',
        zipcodes: 'Zip Code',
        member_ref: 'Audience',
        languages: 'Languages',
        channels: 'Channels',
        tags_summary: 'Tags',
        reSendEligibleCount: 'Re-run Eligible Count'
    },
    rerunConfirm: {
        timestamp: 'Timestamp',
        centers: 'Audience',
        org_labels: 'Organization Labels',
        member_ref: 'Audience',
        languages: 'Languages',
        channels: 'Channels',
        tags_summary: 'Tags'
        // sent: "# of members sent to",
        // senderPhone: "Sender Phone #"
    }
};

export const PROGRAM_DETAIL_KEY: { [k: string]: { [l: string]: string } } = {
    preview: {
        program_ref: 'Event ID',
        eventStatus: 'Status',
        event_start_timestamp: 'Event Start Date',
        event_end_timestamp: 'Event End Date',
        event_start_time: 'Event Start Time',
        audience: 'Audience',
        sentTo: 'Sent To',
        dateSent: 'Sent Date',
        created_by: 'Created By',
        created_date: 'Created On',
        portal_updated_by: 'Last Updated By',
        updated_on: 'Last Updated On'
    }
};

export enum AnalyticLogLabels {
    ServerError = 'server_error',
    BroadcastSend = 'broadcast_send_click',
    BroadcastScheduleSend = 'broadcast_schedule_send_click',
    BroadcastScheduleUpdate = 'broadcast_schedule_update_click',
    BroadcastSchedulePreview = 'broadcast_schedule_preview_click',
    BroadcastDelete = 'broadcast_delete_click',
    BroadcastScheduleListReset = 'broadcast_schedule_list_reset_click',
    BroadcastHistoryListReset = 'broadcast_history_list_reset_click',
    BroadcastHistoryListFilter = 'broadcast_history_list_filter_click',
    BroadcastAddFileCtaClicked = 'broadcast_add_file_cta_clicked',
    BroadcastAttachmentUploadStatus = 'attachment_upload_status',
    BroadcastAttachmentRemoved = 'attachment_removed',
    BroadcastAttachmentDownloaded = 'attachment_downloaded',
    BroadcastChatGPTMessageGenerate = 'broadcast_chatgpt_message_created',
    BroadcastChatGPTMessageCopied = 'broadcast_chat_gpt_message_copied',
    BroadcastChannelToggled = 'broadcast_channel_toggled',
    BroadcastCommunicationTagSelected = 'broadcast_communication_tag_selected',
    BroadcastLanguageDropdown = 'broadcast_language_dropdown',
    BroadcastFormSubmitted = 'broadcast_form_submitted',
    TranslationPreviewClicked = 'translation_preview_clicked',
    TranslationPreviewDisplayed = 'translation_preview_displayed',
    AutoTranslateDisabled = 'auto_translate_disabled',
    AutoTranslateEnabled = 'auto_translate_enabled',
    WelcomeChatGPTMessageGenerate = 'welcome_chatgpt_message_created',
    WelcomeSend = 'welcome_send_click',
    ForgetPassword = 'forgot_password_click',
    UserLogout = 'user_logout_click',
    SetPassword = 'set_password_click',
    ProgramCreated = 'program_created_click',
    ProgramUpdated = 'program_updated_click',
    ReminderAlertCreated = 'reminder_alert_created_click',
    ReminderAlertUpdated = 'reminder_alert_updated_click',
    EventReminderHistoryPageSearchUsed = 'event_reminder_search_used',
    EventReminderHistoryPageEventIdClicked = 'event_reminder_history_event_clicked',
    EventReminderHistoryPagePaginationUsed = 'event_reminder_pagination_used',
    EventReminderHistoryEventViewed = 'event_reminder_history_event_viewed',
    EventReminderAddMoreReminder = 'event_reminder_add_more_reminder',
    EventReminderEventDuplicated = 'event_reminder_event_duplicated',
    EventReminderEventDeleted = 'event_reminder_event_deleted',
    EventReminderScheduledAlertsOpened = 'event_reminder_scheduled_alerts_opened',
    EventReminderEventDetailsOpened = 'event_reminder_event_details_opened',
    EventReminderEventClicked = 'event_reminder_event_clicked',
    EventReminderFormSubmitted = 'event_reminder_form_submitted',
    SurveyCreated = 'survey_created_click',
    SurveyUpdated = 'survey_updated_click',
    SurveyDelete = 'survey_delete_click',
    SurveySent = 'survey_sent_click',
    SurveyConversationalAiSent = 'survey_conversational_ai_sent',
    SurveyScheduleSend = 'survey_schedule_send_click',
    SurveyScheduleUpdate = 'survey_schedule_update_click',
    SurveyScheduleDelete = 'survey_schedule_delete_click',
    SurveyDuplicate = 'survey_duplicate_click',
    SurveyReSent = 'survey_resent_click',
    SurveyResDownload = 'survey_responses_download_click',
    SurveyVisualDownload = 'survey_visualization_download_click',
    SendSurveyDetails = 'send_survey_details_click',
    ReSendSurveyDetails = 'resend_survey_details_click',
    SurveyHistoryExpand = 'survey_history_expand_click',
    SurveyTranslationViewed = 'survey_translation_viewed',
    SurveyConditionalBranchingEnabled = 'survey_conditional_branching_enabled',
    SurveyConditionalBranchingDisabled = 'survey_conditional_branching_disabled',
    SurveyFinalSaved = 'survey_final_saved',
    CreateSurveyClicked = 'create_survey_clicked',
    CreateSurveyDetailsSaved = 'create_survey_details_saved',
    CreateSurveyQuestionsSaved = 'create_survey_questions_saved',
    SendSurveySubmitted = 'send_survey_submitted',
    SendSurveyCreateRerunCtaClicked = 'send_survey_create_rerun_cta_clicked',
    SendSurveyTagsCleared = 'send_survey_tags_cleared',
    SendSurveyChannelsDropdown = 'send_survey_channels_dropdown',
    SendSurveyLanguageDropdown = 'send_survey_language_dropdown',
    SendSurveyViewQuestionsClicked = 'send_survey_view_questions_clicked',
    CreateSurveyDetailsActionClicked = 'create_survey_details_action_clicked',
    UserCreated = 'user_created_click',
    UserDeleted = 'user_deleted_click',
    UserListDownload = 'user_list_download_click',
    UserMedicaidInfoViewed = 'medicaid_information_viewed',
    UserShowInterestSelectionNotificationShowed = 'interest_category_selection_notification',
    UserShowInterestSelectionNotificationIgnored = 'interest_category_notification_ignored',
    UserShowInterestSelectionNotificationAcknowledged = 'interest_category_notification_acknowledged',
    SelectSpecificIndividualReceipents = 'select_specific_individual_receipents_click',
    IndividualUsersSelectedMembers = 'individual_users_selected_members_click',
    IndividualUsersSelectedMembersClearAll = 'individual_users_selected_members_clear_all_click',
    InterestCategoryCreated = 'interest_category_created',
    InterestCategoryViewed = 'interest_category_viewed',
    InterestCategoryError = 'interest_category_error',
    InterestOpenSideDrawer = 'view_users',
    InterestCloseSideDrawer = 'close_view_users',
    InterestCategoryManagement = 'interest_category_management',
    InterestCategoryEditUser = 'edit_user',
    InterestCategoryEditMode = 'edit_mode',
    InterestCategoryModifyUserSelection = 'modify_user_selection',
    InterestCategoryUserAdded = 'user_added',
    InterestCategoryUserRemoved = 'user_removed',
    InterestCategoryChangeTypeAdded = 'added',
    InterestCategoryChangeTypeRemoved = 'removed',
    InterestCategorySaveUserEdits = 'save_user_edits',
    InterestCategorySaveEdits = 'save_edits',
    InterestCategoryApplyTableFilter = 'apply_filter',
    InterestCategoryFilterUsers = 'filter_users',
    BulkUploadClicked = 'bulk_upload_clicked',
    BulkUploadFileUploaded = 'bulk_upload_file_uploaded',
    BulkUploadHistoryViewed = 'bulk_upload_history_viewed',
    RestrictedHoursWarning = 'restricted_hours_warning',
    RestrictedHoursConfirmed = 'restricted_hours_confirmed',
    RestrictedHoursCancelled = 'restricted_hours_canceled',
    PortalUserFilter = 'portal_user_filter',
    PortalUserCreationOpen = 'portal_user_creation_open',
    PortalUserFieldInput = 'portal_user_field_input',
    PortalUserPasswordReset = 'portal_user_password_reset',
    LabelsOpenSideDrawer = 'view_users',
    LabelManagement = 'label_management',
    LabelEditUser = 'edit_user',
    LabelEditMode = 'edit_mode',
    LabelModifyUserSelection = 'modify_user_selection',
    LabelUserAdded = 'user_added',
    LabelUserRemoved = 'user_removed',
    LabelChangeTypeAdded = 'added',
    LabelChangeTypeRemoved = 'removed',
    LabelSaveUserEdits = 'save_user_edits',
    LabelSaveEdits = 'save_edits',
    LabelApplyTableFilter = 'apply_filter',
    LabelFilterUsers = 'filter_users',
    LabelViewed = 'label_viewed',
    LabelError = 'label_error',
    LabelCloseSideDrawer = 'close_view_users',
    CreateOutgoingReferralSectionExpanded = 'create_outgoing_referral_section_expanded',
    CreateIncomingReferralSectionExpanded = 'create_incoming_referral_section_expanded',
    CreateOutgoingReferralFormSubmitted = 'create_outgoing_referral_form_submitted',
    CreateOutgoingReferralFormReset = 'create_outgoing_referral_form_reset',
    CreateOutgoingReferralMemberSelected = 'create_outgoing_referral_member_selected',
    CreateOutgoingReferralNeedSelected = 'create_outgoing_referral_need_selected',
    CreateOutgoingReferralProviderSelected = 'create_outgoing_referral_provider_selected',
    CreateOutgoingReferralConsentChecked = 'create_outgoing_referral_consent_checked',
    ReferralCommentAdded = 'referral_comment_added',
    LabelPortalUserCreated = 'portal_user_created',
    LabelPortalUserCreationError = 'portal_user_creation_error',
    LabelPortalUsersStatusViewed = 'portal_users_status_viewed',
    LabelPortalUserDeactivationCancelled = 'portal_user_deactivation_cancelled',
    LabelPortalUserDeactivated = 'portal_user_deactivated',
    LabelPortalUserDeactivationError = 'portal_user_deactivation_error',
    LabelPortalUserReactivationCancelled = 'portal_user_reactivation_cancelled',
    LabelPortalUserReactivated = 'portal_user_reactivated',
    LabelPortalUserReactivationError = 'portal_user_reactivation_error',
    LabelPortalUserPasswordResetError = 'portal_user_password_reset_error',
    LabelPortalUserActivationResent = 'portal_user_activation_resent',
    LabelPortalUserActivationResendError = 'portal_user_activation_resend_error',
    LabelPortalUserRoleChanged = 'portal_user_role_changed',
    LabelPortalUserRoleChangeCancelled = 'portal_user_role_change_cancelled',
    LabelPortalUserRoleChangeError = 'portal_user_role_change_error',
    LabelPortalUserRoleSelected = 'portal_user_role_selected',
    LabelSettingsLanguagesDrawerOpened = 'settings_languages_drawer_opened',
    LabelSettingsUserLanguageDrawerClosed = 'settings_user_language_drawer_closed',
    LabelSettingsLanguageEnabledSuccess = 'settings_language_enabled_success',
    LabelSettingsLanguageDisableConfirmed = 'settings_language_disable_confirmed',
    LabelSettingsLanguageDisableCancelled = 'settings_language_disable_cancelled',
    LabelSettingsLanguageDisabled = 'settings_language_disabled',
    LabelSettingsLanguagePerformanceWarningShown = 'settings_language_performance_warning_shown',
    LabelSettingsLanguageSearchPerformed = 'settings_language_search_performed',
    LabelSettingsLanguagePermissionDenied = 'settings_language_permission_denied',
    WorkflowCanvasOpened = 'workflow_canvas_opened',
    WorkflowRenamed = 'workflow_renamed',
    WorkflowBlockConfigPanel = 'workflow_block_config_panel',
    WorkflowStateChanged = 'workflow_state_changed',
    WorkflowLifecycle = 'workflow_lifecycle',
    WorkflowVersionCreate = 'workflow_version_create',
    WorkflowDuplicate = 'workflow_duplicate',
    WorkflowValidationError = 'workflow_validation_error',
    WorkflowSingleCallToggle = 'workflow_single_call_toggle',
    WorkflowCanvasOperation = 'workflow_canvas_operation',
    WorkflowPreviewClicked = 'workflow_preview_clicked',
    WorkflowTestClicked = 'workflow_test_clicked',
    BlockAdded = 'workflow_block_added',
    BlockManagement = 'workflow_block_management',
    BlockConfigureOpen = 'workflow_block_configure_open',
    WorkflowBlockConfigSaved = 'workflow_block_config_saved',
    AnalyticsPanelOpen = 'workflow_analytics_panel_open',
    AnalyticsFilterApply = 'workflow_analytics_filter_apply',
    AnalyticsUserSearch = 'workflow_analytics_user_search',
    AnalyticsDataDownload = 'workflow_analytics_data_download',
    GuidedTourInteraction = 'workflow_guided_tour_interaction',
    UserListExport = 'user_list_export',
    UserListColumnsCustomized = 'user_list_columns_customized',
    UserListPaginationPageSelected = 'user_list_pagination_page_selected',
    UserListSortApplied = 'user_list_sort_applied',
    UserListFilter = 'user_list_filter',
    UserBulkUploadErrorDownloadClicked = 'user_bulk_upload_error_download_clicked',
    UserBulkUploadSuccessful = 'user_bulk_upload_successful',
    UserProfileEdited = 'user_profile_edited',
    UserCreateHouseholdSection = 'user_create_household_section',
    UserCreateDemographicSection = 'user_create_demographic_section',
    UserCreatePreferredLanguageDropdownOpened = 'user_create_preferred_language_dropdown_opened',
    UserCreateProgramsDropdownOpened = 'user_create_programs_dropdown_opened',
    UserCreateFormResetClicked = 'user_create_form_reset_clicked',
    UserCreateFormSubmitted = 'user_create_form_submitted',
    // Settings analytics events
    SettingsPrivacyPolicyView = 'settings_privacy_policy_view',
    SettingsTermsOfServiceView = 'settings_terms_of_service_view',
    SettingsAdminDocView = 'settings_admin_doc_view',
    SettingsMfaToggled = 'settings_mfa_toggled',
    SettingsEditUsersLabelSearchPerformed = 'settings_edit_users_label_search_performed',
    SettingsEditUsersLabelMemberModified = 'settings_edit_users_label_member_modified',
    SettingsLabelUserCountClicked = 'settings_label_user_count_clicked',
    SettingsEditUsersInterestCategorySaved = 'settings_edit_users_interest_category_saved',
    SettingsLabelSearchPerformed = 'settings_label_search_performed',
    SettingsLabelFormSubmitted = 'settings_label_form_submitted',
    SettingsAddLabelButtonClicked = 'settings_add_label_button_clicked',
    SettingsLabelsDrawer = 'settings_labels_drawer',
    SettingsInterestFormSubmitted = 'settings_interest_form_submitted',
    SettingsInterestsDrawer = 'settings_interests_drawer',
    SettingsOrganizationDropdown = 'settings_organization_dropdown',
    SettingsTransferUsersLabelModified = 'settings_transfer_users_label_modified',
    LabelSettingsProgramsDrawerOpened='settings_programs_drawer_opened',
    LabelSettingsProgramCreationForm='settings_program_creation_form',
    LabelSettingsProgramFieldSaved = 'settings_program_field_saved',
    LabelSettingsProgramFieldUpdated = 'settings_program_field_updated',
    LabelSettingsProgramArchiveConfirmationShows = 'settings_program_archive_confirmation_shows',
    LabelSettingsProgramArchiveCancelled = 'settings_program_archive_cancelled',
    LabelSettingsProgramArchiveConfirmed = 'settings_program_archive_confirmed',
    LabelSettingsProgramAddUsersSearchPerformed = 'settings_program_add_users_search_performed',
    LabelSettingsProgramUsersAdded = 'settings_program_users_added',
    LabelSettingsProgramUsersRemoved = 'settings_program_users_removed',
    LabelSettingsProgramTransferP2pCompleted = 'settings_program_transfer_p2p_completed',
    LabelSettingsProgramTransferP2icCompleted = 'settings_program_transfer_p2ic_completed',
    LabelSettingsProgramTransferP2lCompleted = 'settings_program_transfer_p2l_completed',
    LabelSettingsProgramTransferP2oCompleted = 'settings_program_transfer_p2o_completed',
    LabelSettingsProgramTransferO2pCompleted = 'settings_program_transfer_o2p_completed',
    LabelSettingsProgramUsersFilterApplied = 'settings_program_users_filter_applied',
    LabelSettingsProgramDetailsViewed = 'settings_program_details_viewed',
    LabelSettingsVoiceGreetingsDrawerOpened = 'settings_voice_greetings_drawer_opened',
    LabelSettingsVoiceGreetingsDrawerClosed = 'settings_voice_greetings_drawer_closed',
    LabelSettingsVoiceGreetingCreationMethodSelected = 'settings_voice_greeting_creation_method_selected',
    LabelSettingsVoiceGreetingUploadInitiated = 'settings_voice_greeting_upload_initiated',
    LabelSettingsVoiceGreetingUploaded = 'settings_voice_greeting_uploaded',
    LabelSettingsVoiceGreetingMicPermissionRequested = 'settings_voice_greeting_mic_permission_requested',
    LabelSettingsVoiceGreetingMicPermissionGranted = 'settings_voice_greeting_mic_permission_granted',
    LabelSettingsVoiceGreetingMicPermissionDenied = 'settings_voice_greeting_mic_permission_denied',
    LabelSettingsVoiceGreetingRecordingStarted = 'settings_voice_greeting_recording_started',
    LabelSettingsVoiceGreetingRecordingStopped = 'settings_voice_greeting_recording_stopped',
    LabelSettingsVoiceGreetingRecordingPreviewed = 'settings_voice_greeting_recording_previewed',
    LabelSettingsVoiceGreetingRecordingRetried = 'settings_voice_greeting_recording_retried',
    LabelSettingsVoiceGreetingRecorded = 'settings_voice_greeting_recorded',
    LabelSettingsVoiceGreetingAi = 'settings_voice_greeting_ai',
    LabelSettingsVoiceGreetingReplaceInitiated = 'settings_voice_greeting_replace_initiated',
    LabelSettingsVoiceGreetingReplaced = 'settings_voice_greeting_replaced',
    LabelSettingsVoiceGreetingRemoved = 'settings_voice_greeting_removed',
    LabelSettingsActivateNewUsersDrawerOpened = 'settings_activate_new_users_drawer_opened',
    LabelSettingsActivateDrawerClosed = 'settings_activate_drawer_closed',
    LabelSettingsActivateNewUsersHistoryTabViewed = 'settings_activate_new_users_history_tab_viewed',
    LabelSettingsActivateOrgDefaultMessageEdited = 'settings_activate_org_default_message_edited',
    LabelSettingsActivateProgramOverrideAdded = 'settings_activate_program_override_added',
    LabelSettingsActivateProgramOverrideEdited = 'settings_activate_program_override_edited',
    LabelSettingsActivateCharacterLimitReached = 'settings_activate_character_limit_reached',
    LabelSettingsActivatePersonalizationTokenUsed = 'settings_activate_personalization_token_used',
    LabelSettingsActivateGenerateAiMessageClicked = 'settings_activate_generate_ai_message_clicked',
    LabelSettingsActivateAiMessageGenerated = 'settings_activate_ai_message_generated',
    LabelSettingsActivateAiGenerationFailed = 'settings_activate_ai_generation_failed',
    LabelSettingsActivateChannelAccordionExpanded = 'settings_activate_channel_accordion_expanded',
    LabelSettingsActivateChannelAccordionCollapsed = 'settings_activate_channel_accordion_collapsed',
    LabelSettingsActivateAutoTranslateToggled = 'settings_activate_auto_translate_toggled',
    LabelSettingsActivateTranslationPreviewClicked = 'settings_activate_translation_preview_clicked',
    LabelSettingsActivateManualTranslationEntered = 'settings_activate_manual_translation_entered',
    LabelSettingsActivateSendImmediatelySelected = 'settings_activate_send_immediately_selected',
    LabelSettingsActivateScheduledSendSelected = 'settings_activate_scheduled_send_selected',
    LabelSettingsActivateSendTimeAdded = 'settings_activate_send_time_added',
    LabelSettingsActivateSendTimeRemoved = 'settings_activate_send_time_removed',
    LabelSettingsActivateBusinessHoursChecked = 'settings_activate_business_hours_checked',
    LabelSettingsActivateConfigurationSaved = 'settings_activate_configuration_saved',
    LabelSettingsActivateBulkSendClicked = 'settings_activate_bulk_send_clicked',
    LabelSettingsActivateBulkSendCompleted = 'settings_activate_bulk_send_completed',
    LabelSettingsActivateBulkSendFailed = 'activate_bulk_send_failed',
    LabelSettingsActivateHistorySearchPerformed = 'settings_activate_history_search_performed',
    LabelSettingsActivateHistoryChannelFiltered = 'settings_activate_history_channel_filtered',
    LabelSettingsActivateHistoryDateFiltered = 'settings_activate_history_date_filtered',
    LabelSettingsActivateHistoryCustomDateSelected = 'settings_activate_history_custom_date_selected',
    LabelSettingsActivateHistoryRowExpanded = 'settings_activate_history_row_expanded',
    LabelSettingsActivateHistoryRowCollapsed = 'settings_activate_history_row_collapsed',
    LabelSettingsActivateHistoryPaginationClicked = 'settings_activate_history_pagination_clicked',
    LabelSettingsActivateHistoryRowsPerPageChange = 'settings_activate_history_rows_per_page_change',
    LabelSettingsActivateHistoryCsvDownloaded = 'settings_activate_history_csv_downloaded',
    LabelSettingsOrgProfileDrawer = 'settings_org_profile_drawer',
    LabelSettingsOrgProfileTabViewed = 'settings_org_profile_tab_viewed',
    LabelSettingsOrgProfileLogoUploaded = 'settings_org_profile_logo_uploaded',
    LabelSettingsOrgProfileLogoError = 'settings_org_profile_logo_error',
    LabelSettingsOrgProfileFieldEdited = 'settings_org_profile_field_edited',
    LabelSettingsOrgProfileAddressSyncTriggered = 'settings_org_profile_address_sync_triggered',
    LabelSettingsOrgProfileValidationError = 'settings_org_profile_validation_error',
    LabelSettingsOrgProfileSaveClicked = 'settings_org_profile_save_clicked',
    LabelSettingsOrgProfileSaveSuccess = 'settings_org_profile_save_success',
    LabelSettingsOrgProfileSaveFailed = 'settings_org_profile_save_failed',
    LabelSettingsCustomFieldModalOpened = 'settings_custom_field_modal_opened',
    LabelSettingsAddFieldButtonClicked = 'settings_add_field_button_clicked',
    LabelSettingsCustomFieldCreated = 'settings_custom_field_created',
    LabelSettingsCustomFieldSearchPerformed = 'settings_custom_field_search_performed',
    LabelSettingsCustomFieldEditClicked = 'settings_custom_field_edit_clicked',
    LabelSettingsCustomFieldEditUpdated = 'settings_custom_field_edit_updated',
    LabelSettingsCustomFieldStatusChanged = 'settings_custom_field_status_changed',
    LabelSettingsHistoryLogDrawer = 'settings_history_log_drawer',
    LabelSettingsHistoryLogSearchPerformed = 'settings_history_log_search_performed',
    LabelSettingsHistoryLogDateFilterApplied = 'settings_history_log_date_filter_applied',
    LabelSettingsHistoryLogSectionFilterApplied = 'settings_history_log_section_filter_applied',
    LabelSettingsHistoryLogUsernameFilterApplied = 'settings_history_log_username_filter_applied',
    LabelSettingsHistoryLogFiltersCleared = 'settings_history_log_filters_cleared',
    LabelSettingsHistoryLogRow = 'settings_history_log_row',
    LabelSettingsHistoryLogCsvDownloaded = 'settings_history_log_csv_downloaded',
    LabelSettingsHistoryLogPaginationClicked = 'settings_history_log_pagination_clicked',
    LabelSettingsHistoryLogRowsPerPageChanged = 'settings_history_log_rows_per_page_changed',
    SettingsLabelStatusChanged = 'settings_label_status_changed',
    SettingsTransferUsersInterestModified = 'settings_transfer_users_interest_modified',
    SettingsInterestUserCountClicked = 'settings_interest_user_count_clicked',
    SettingsAddInterestButtonClicked = 'settings_add_interest_button_clicked',
    OptimizationClick = 'optimization_click',
    SegmentThresholdAlert = 'segment_threshold_alert',
    UrlWarning = 'url_warning',
    CharWarning = 'char_warning',
    EncodingSwitch = 'encoding_switch',
    InfoIconClicked = 'info_icon_clicked',
    TranslationMultiplier = 'translation_multiplier',
    CaregiverAssigned = 'caregiver_assigned',
    CaregiverReassigned = 'caregiver_reassigned',
    CaregiverUnassigned = 'caregiver_unassigned',
    CaregiverProfileViewed = 'caregiver_profile_viewed',
    HouseholdMemberProfileViewed = 'household_member_profile_viewed',
    PrimaryUserProfileViewed = 'primary_user_profile_viewed',
    PrimaryUserLinkClicked = 'primary_user_link_clicked',
    HouseholdMemberLinkClicked = 'household_member_link_clicked',
    HouseholdListPaginated = 'household_list_paginated',
}

export enum AnalyticFilterSearchLabels {
    UserListSearchPerformed = 'user_list_search_performed',
    UserSearchPerformed = 'user_search_performed',
    UserSearchFilterMedicaidId = 'user_search_filter_medicaid_id',
    PortalUserSearchPerformed = 'portal_user_search_performed',
    PortalUserSearchFilterSelected = 'portal_user_search_filter_selected',
    PortalUserFilterStatus = 'portal_user_filter_status',
    WorkflowSearchPerformed = 'workflow_search_performed',
    ArchivedWorkflowSearchPerformed = 'archived_workflow_search_performed',
    WorkflowStatusFiltered = 'workflow_status_filtered',
    SurveySearchPerformed = 'survey_search_performed',
    SurveyStatus = 'survey_status',
    SurveyHistorySearchPerformed = 'survey_history_search_performed',
    SurveyHistoryFilterTagSelected = 'survey_history_filter_tag_selected',
    EventReminderSearchPerformed = 'event_reminder_search_performed',
    EventReminderStatusFilter = 'event_reminder_status_filter',
    EventReminderHistorySearch = 'event_reminder_history_search',
    BroadcastHistoryTypeFilterApplied = 'broadcast_history_type_filter_applied',
    BroadcastHistoryFilterLanguageSelected = 'broadcast_history_filter_language_selected',
    BroadcastAllTypeDeselected = 'broadcast_all_type_deselected',
    BroadcastTypeFilter = 'broadcast_type_filter',
    BroadcastAllTagsDeselected = 'broadcast_all_tags_deselected',
    BroadcastTagFilterApplied = 'broadcast_tag_filter_applied',
    BroadcastHistorySearchPerformed = 'broadcast_history_search_performed',
    BroadcastHistorySearchFilter = 'broadcast_history_search_filter',
    BroadcastSearchPerformed = 'broadcast_search_performed',
    OutgoingReferralOrganizationSelected = 'outgoing_referral_organization_selected',
    OutgoingReferralsSearchPerformed = 'outgoing_referrals_search_performed',
    OutgoingReferralsSearchFilterSelected = 'outgoing_referrals_search_filter_selected',
    OutgoingReferralsNeedFiltered = 'outgoing_referrals_need_filtered',
    OutgoingReferralsFiltered = 'outgoing_referrals_filtered',
    IncomingReferralsSearchPerformed = 'incoming_referrals_search_performed',
}

export enum APIRequestLabels {
    getConstData = 'getConstData_API',
    getAllTagData = 'getAllTagData_API',
    getOrganizationAddress = 'getOrganizationAddress_API',
    updateOrganizationAddress = 'updateOrganizationAddress_API',
    createTagData = 'createTagData_API',
    getCustomFields = 'getCustomFields_API',
    createCustomField = 'createCustomField_API',
    updateCustomField = 'updateCustomField_API',
    updateCustomFieldStatus = 'updateCustomFieldStatus_API',
    getCustomFieldsScheduledCommunication = 'getCustomFieldsScheduledCommunication_API',
    generateBulkUploadSampleFiles = 'generateBulkUploadSampleFiles_API',
    getCurrentUser = 'getCurrentUser_API',
    acceptTermsPolicy = 'acceptTermsPolicy_API',
    getOrganizations = 'getOrganizations_API',
    getOrganizationsAsync = 'getOrganizationsAsync_API',
    getSeniorcenterByOrgId = 'getSeniorcenterByOrgId_API',
    getOrganizationLanguages = 'getOrganizationLanguages_API',
    translateTextByLanguage = 'translateTextByLanguage_API',
    getReports = 'getReports_API',
    getServiceDownBanner = 'getServiceDownBanner_API',
    sendBroadcast = 'sendBroadcast_API',
    downloadBroadcastAttachment = 'downloadBroadcastAttachment_API',
    getSuggestMessage = 'getSuggestMessage_API',
    sendBroadcastPreview = 'sendBroadcastPreview_API',
    sendWelcomeMessage = 'sendWelcomeMessage_API',
    getBroadcastHistory = 'getBroadcastHistory_API',
    getBroadcastHistoryRefresh = 'getBroadcastHistoryRefresh_API',
    getBroadcastSentUsers = 'getBroadcastSentUsers_API',
    getScheduledBroadcast = 'getScheduledBroadcast_API',
    getBroadcastDataById = 'getBroadcastDetails_API',
    updateBroadcast = 'updateBroadcast_API',
    deleteBroadcast = 'deleteBroadcast_API',
    checkAudienceDedup = 'checkAudienceDedup_API',
    getOrgUsers = 'getOrgUsers_API',
    getOrgUsersWithParams = 'getOrgUsersWithParams_API',
    getOrgUsersWithFilters = 'getOrgUsersWithFilters_API',
    getUserInterests = 'getUserInterests_API',
    getInterestAssociationsByOrgId = 'getInterestAssociationsByOrgId_API',
    getInterestsDetailsByOrgId = 'getInterestsDetailsByOrgId_API',
    getUsersInInterest = 'getUsersInInterest_API',
    getUsersInInterestNoPagination = 'getUsersInInterestNoPagination_API',
    createInterest = 'createInterest_API',
    getPortalUsersByOrgId = 'getPortalUsersByOrgId_API',
    createPortalUsers = 'createPortalUsers_API',
    updatePortalUsers = 'updatePortalUsers_API',
    resendActivationLink = 'resendActivationLink_API',
    getUserByMemberId = 'getUserByMemberId_API',
    postNewUser = 'postNewUser_API',
    updateUser = 'updateUser_API',
    deleteUserByMemberId = 'deleteUserByMemberId_API',
    updateRemoveClientInterests = 'updateRemoveClientInterests_API',
    getUserDownloadLink = 'getUserDownloadLink_API',
    getUserDownloadLinkV2 = 'getUserDownloadLinkV2_API',
    userBulkUpload = 'userBulkUpload_API',
    userBulkUploadV2 = 'userBulkUploadV2_API',
    getBulkUploadFilesAsblob = 'getBulkUploadFilesAsblob_API',
    getUserByOrgMemberIdV2 = 'getUserByOrgMemberIdV2_API',
    getAllOrgUsersV2 = 'getAllOrgUsersV2_API',
    addOrgUserV2 = 'addOrgUserV2_API',
    updateOrgUserV2 = 'updateOrgUserV2_API',
    deleteUserByMemberIdV2 = 'deleteUserByMemberIdV2_API',
    getOrgPrograms = 'getOrgPrograms_API',
    getOrgProgramsWithParams = 'getOrgProgramsWithParams_API',
    getOrgProgramsByID = 'getOrgProgramsByID_API',
    getOrgProgramByRef = 'getOrgProgramByRef_API',
    getReminderHistoryOrgPrograms = 'getReminderHistoryOrgPrograms_API',
    getReminderHistoryOrgProgramsWithParams = 'getReminderHistoryOrgProgramsWithParams_API',
    getHistoryOrgProgramByRef = 'getHistoryOrgProgramByRef_API',
    addProgram = 'addProgram_API',
    updateProgram = 'updateProgram_API',
    deleteProgram = 'deleteProgram_API',
    getReminders = 'getReminders_API',
    getRemindersWithParams = 'getRemindersWithParams_API',
    addReminder = 'addReminder_API',
    updateReminder = 'updateReminder_API',
    getOrgSurveys = 'getOrgSurveys_API',
    getOrgScheduledSurveys = 'getOrgScheduledSurveys_API',
    getOrgSurveysWithParams = 'getOrgSurveysWithParams_API',
    getSurveyWithResponseAndQuestions = 'getSurveyWithResponseAndQuestions_API',
    getSurveyResponseByDates = 'getSurveyResponseByDates_API',
    getOrgSurveysByID = 'getOrgSurveysByID_API',
    addSurvey = 'addSurvey_API',
    updateSurvey = 'updateSurvey_API',
    deleteSurvey = 'deleteSurvey_API',
    updateScheduledSurvey = 'updateScheduledSurvey_API',
    deleteScheduledSurvey = 'deleteScheduledSurvey_API',
    getSurveyQuestions = 'getSurveyQuestions_API',
    getSurveyQuestionsByLanguage = 'getSurveyQuestionsByLanguage_API',
    getSurveyQuestionsResponse = 'getSurveyQuestionsResponse_API',
    getSurveyQuestionsCount = 'getSurveyQuestionsCount_API',
    addSurveyQuestions = 'addSurveyQuestions_API',
    updateSurveyQuestions = 'updateSurveyQuestion_API',
    updateSurveyQuestionsOrder = 'updateSurveyQuestionsOrder_API',
    deleteSurveyQuestions = 'deleteSurveyQuestions_API',
    getSurveyQuestionsV2 = 'getSurveyQuestionsV2_API',
    addSurveyQuestionsV2 = 'addSurveyQuestionsV2_API',
    updateSurveyQuestionsV2 = 'updateSurveyQuestions_API',
    deleteSurveyQuestionsV2 = 'deleteSurveyQuestionsV2_API',
    sendSurvey = 'sendSurvey_API',
    getSurveyHistory = 'getSurveyHistory_API',
    getSurveyHistoryRefresh = 'getSurveyHistoryRefresh_API',
    getSurveyHistoryDetail = 'getSurveyHistoryDetail_API',
    getSurveySentUsers = 'getSurveySentUsers_API',
    getSurveyInstanceHistoryDetail = 'getSurveyInstanceHistoryDetail_API',
    getSurveyRerunsCount = 'getSurveyRerunsCount_API',
    getUpcomingScheduledSurveys = 'getUpcomingScheduledSurveys_API',
    sendSurveyHistoryRerun = 'sendSurveyHistoryRerun_API',
    getSurveyResponses = 'getSurveyResponses_API',
    signIn = 'signIn_API',
    forgotPassword = 'forgotPassword_API',
    setPassword = 'setPassword_API',
    validateToken = 'validateToken_API',
    getReferrals = 'getReferrals_API',
    getReferralById = 'getReferralById_API',
    getReferralNeedCategory = 'getReferralNeedCategory_API',
    getReferralNeedByID = 'getReferralNeedByID_API',
    getReferralNeedForFilter = 'getReferralNeedForFilter_API',
    getReferredToFilter = 'getReferredToFilter_API',
    getServiceProvidersByNeedId = 'getServiceProvidersByNeedId_API',
    registerNeeds = 'registerNeeds_API',
    submitReferrals = 'submitReferrals_API',
    updateReferralStatus = 'updateReferralStatus_API',
    updateReferral = 'updateReferral_API',
    getExternalUserComment = 'getExternalUserComment_API',
    addExternalUserComment = 'addExternalUserComment_API',
    referralEmailValidateCode = 'referralEmailValidateCode_API',
    referralEmailConfirm = 'referralEmailConfirm_API',
    unlockAccount = 'unlockAccount_API',
    portalUserForgotPassword = 'portalUserForgotPassword_API',
    updatePortalUserStatus = 'updatePortalUserStatus_API',
    getAccountLimits = 'getAccountLimits_API',
    getAccountFeatureLimits = 'getAccountFeatureLimits_API',
    enableDisableMFA = 'enableDisableMFA_API',
    loadUserLabels = 'loadUserLabels_API',
    addUserLabel = 'addUserLabel_API',
    updateUserLabels = 'updateUserLabels_API',
    addOrRemoveUserLabels = 'addOrRemoveUserLabels_API',
    getUsersInLabel = 'getUsersInLabel_API',
    getUsersInLabelNoPagination = 'getUsersInLabelNoPagination_API',
    getOrgLabelsScheduledCommunication = 'getOrgLabelsScheduledCommunication_API',
    getProgramScheduledCommunications = 'getProgramScheduledCommunications_API',
    getAllWorkflows = 'getAllWorkflows_API',
    getWorkflowById = 'getWorkflowById_API',
    createWorkflow = 'createWorkflow_API',
    updateWorkflow = 'updateWorkflow_API',
    patchWorkflow = 'patchWorkflow_API',
    testWorkflow = 'testWorkflow_API',
    deleteWorkflow = 'deleteWorkflow_API',
    getWorkflowVersionsById = 'getWorkflowVersionsById_API',
    createWorkflowVersion = 'createWorkflowVersion_API',
    activateWorkflowVersion = 'activateWorkflowVersion_API',
    deleteWorkflowVersion = 'deleteWorkflowVersion_API',
    getDuplicateWorkflow = 'getDuplicateWorkflow_API',
    surveyWorkflowExists = 'surveyWorkflowExists_API',
    needWorkflowExists = "needWorkflowExists_API",
    disableGuidedTourWorkflow = 'disableGuidedTourWorkflow_API',
    previewWorkflow = 'previewWorkflow_API',
    getOrganizationFilters = 'getOrganizationFilters_API',
    getTableauJwtToken = 'getTableauJwtToken_API',
    validateTableauSite = 'validateTableauSite_API',
    getProgramsByOrgId = 'getProgramsByOrgId_API',
    getOrganizationTimezones = 'getOrganizationTimezones_API',
    getOrgServiceTypes = 'getOrgServiceTypes_API',
    createServiceData = 'createServiceData_API',
    addSelfServiceProgram = 'addSelfServiceProgram_API',
    updateSelfServiceProgram = 'updateSelfServiceProgram_API',
    getProgramUsers = 'getProgramUsers_API',
    updateProgramUsers = 'updateProgramUsers_API',
    getTransferProgramOptions = 'getTransferProgramOptions_API',
    transferProgramUsers = 'transferProgramUsers_API',
    transferLabelUsers = 'transferLabelUsers_API',
    transferInterestUsers = 'transferInterestUsers_API',
    getIntercomAccessToken = 'getIntercomAccessToken_API',
    getWorkflowAnalyticsDownloadLink = 'getWorkflowAnalyticsDownloadLink_API',
    getOrgActivationSetup = 'getOrgActivationSetup_API',
    getProgramActivationSetup = 'getProgramActivationSetup_API',
    saveActivationSetupRule = 'saveActivationSetupRule_API',
    retieveActivatedUsers = 'retieveActivatedUsers_API',
    retriveNoActiveUsers = 'retriveNoActiveUsers_API',
    downloadActivatedUsers = 'downloadActivatedUsers_API',
    triggerManualActivation = 'triggerManualActivation_API',
    retrievePortalUsersEmails = 'retrievePortalUsersEmails_API',
    retrieveAuditSections = 'retrieveAuditSections_API',
    retrieveAuditLogs = 'retrieveAuditLogs_API',
    downloadAuditLogs = 'downloadAuditLogs_API',
    segmentAnalyzerFullCheck = 'segmentAnalyzerFullCheck_API',
    segmentAnalyzerRiskAccept = 'segmentAnalyzerRiskAccept_API'
}

export const AnalyticAPIReqLabels = APIRequestLabels;

export const pageEvents: { [key: string]: RouteEventData } = {
    default: {
        eventName: 'default_page',
        pageTitle: 'Blooming Health: Enabling Aging in Place via Senior-friendly Technology',
        screenName: 'Blooming Health: Enabling Aging in Place via Senior-friendly Technology'
    },
    referralAuth: {
        eventName: 'referral_auth_page',
        pageTitle: 'Referral Email Authentication',
        screenName: 'Referral Email Authentication - Blooming Health'
    },
    incomingReferrals: {
        eventName: 'incoming_referrals_page',
        pageTitle: 'Incoming Referrals',
        screenName: 'Incoming Referrals - Blooming Health'
    },
    incomingReferralDetails: {
        eventName: 'incoming_referral_details_page',
        pageTitle: 'Incoming Referral Details',
        screenName: 'Incoming Referral Details - Blooming Health'
    },
    dashboard: {
        eventName: 'dashboard_page',
        pageTitle: 'Dashboard',
        screenName: 'Dashboard - Blooming Health'
    },
    broadcastList: {
        eventName: 'broadcast_list_page',
        pageTitle: 'Scheduled Broadcast',
        screenName: 'Scheduled Broadcast - Blooming Health'
    },
    editBroadcast: {
        eventName: 'edit_broadcast_page',
        pageTitle: 'Edit Broadcast',
        screenName: 'Edit Broadcast - Blooming Health'
    },
    sendBroadcast: {
        eventName: 'send_broadcast_page',
        pageTitle: 'Send Broadcast',
        screenName: 'Send Broadcast - Blooming Health'
    },
    welcomeBroadcast: {
        eventName: 'welcome_message_page',
        pageTitle: 'Welcome Message',
        screenName: 'Welcome Message - Blooming Health'
    },
    editWelcomeBroadcast: {
        eventName: 'edit_welcome_message_page',
        pageTitle: 'Edit Welcome Message',
        screenName: 'Edit Welcome Message - Blooming Health'
    },
    welcomeBroadcastList: {
        eventName: 'welcome_message_list_page',
        pageTitle: 'Scheduled Welcome Message',
        screenName: 'Scheduled Welcome Message - Blooming Health'
    },
    broadcastConfirmation: {
        eventName: 'broadcast_confirmation_page',
        pageTitle: 'Broadcast Confirmation',
        screenName: 'Broadcast - Blooming Health'
    },
    welcomeConfirmation: {
        eventName: 'welcome_confirmation_page',
        pageTitle: 'Welcome Confirmation',
        screenName: 'Welcome - Blooming Health'
    },
    broadcastHistory: {
        eventName: 'broadcast_history_page',
        pageTitle: 'Broadcast History',
        screenName: 'Broadcast - Blooming Health'
    },
    survey: {
        eventName: 'survey_page',
        pageTitle: 'Survey',
        screenName: 'Survey - Blooming Health'
    },
    scheduledSurvey: {
        eventName: 'scheduled_survey_page',
        pageTitle: 'Scheduled Survey',
        screenName: 'Scheduled Survey - Blooming Health'
    },
    editScheduledSurvey: {
        eventName: 'edit_scheduled_survey_page',
        pageTitle: 'Edit Scheduled Survey',
        screenName: 'Edit Scheduled Survey - Blooming Health'
    },
    createSurvey: {
        eventName: 'create_survey_page',
        pageTitle: 'Survey Create',
        screenName: 'Survey - Blooming Health'
    },
    editSurvey: {
        eventName: 'edit_survey_page',
        pageTitle: 'Survey Edit',
        screenName: 'Survey - Blooming Health'
    },
    sendSurvey: {
        eventName: 'send_survey_list_page',
        pageTitle: 'Survey Send',
        screenName: 'Survey - Blooming Health'
    },
    sendSurveyDetail: {
        eventName: 'send_survey_detail_page',
        pageTitle: 'Survey Send Detail',
        screenName: 'Survey - Blooming Health'
    },
    sendSurveyPreview: {
        eventName: 'send_survey_preview_page',
        pageTitle: 'Survey Send Preview',
        screenName: 'Survey - Blooming Health'
    },
    sendSurveyConfirmation: {
        eventName: 'send_survey_confirmation_page',
        pageTitle: 'Survey Send Confirmation',
        screenName: 'Survey - Blooming Health'
    },
    historySurvey: {
        eventName: 'history_survey_list_page',
        pageTitle: 'Survey History',
        screenName: 'Survey - Blooming Health'
    },
    historySurveyDetail: {
        eventName: 'history_survey_detail_page',
        pageTitle: 'Survey History Detail',
        screenName: 'Survey - Blooming Health'
    },
    historySurveyPreview: {
        eventName: 'history_survey_preview_page',
        pageTitle: 'Survey Rerun Preview',
        screenName: 'Survey - Blooming Health'
    },
    historySurveyConfirmation: {
        eventName: 'history_survey_confirmation_page',
        pageTitle: 'Survey Rerun Confirmation',
        screenName: 'Survey - Blooming Health'
    },
    surveyInstanceDetail: {
        eventName: 'survey_instance_detail_page',
        pageTitle: 'Survey Instance Detail',
        screenName: 'Survey - Blooming Health'
    },
    organization: {
        eventName: 'organization_page',
        pageTitle: 'Organization',
        screenName: 'Organization - Blooming Health'
    },
    user: {
        eventName: 'user_list_page',
        pageTitle: 'Users',
        screenName: 'Users - Blooming Health'
    },
    createUser: {
        eventName: 'create_user_page',
        pageTitle: 'User Create',
        screenName: 'Users - Blooming Health'
    },
    editUser: {
        eventName: 'edit_user_page',
        pageTitle: 'User Edit',
        screenName: 'Users - Blooming Health'
    },
    createPortalUser: {
        eventName: 'create_portal_user_page',
        pageTitle: 'Portal User Create',
        screenName: 'Portal Users - Blooming Health'
    },
    iam: {
        eventName: 'iam_page',
        pageTitle: 'Iam',
        screenName: 'Iam - Blooming Health'
    },
    usage: {
        eventName: 'usage_page',
        pageTitle: 'Usage & Billings',
        screenName: 'Usage & Billings - Blooming Health'
    },
    settings: {
        eventName: 'settings_page',
        pageTitle: 'Settings',
        screenName: 'Settings - Blooming Health'
    },
    program: {
        eventName: 'program_list_page',
        pageTitle: 'Event Reminders',
        screenName: 'Event Reminders - Blooming Health'
    },
    editProgram: {
        eventName: 'edit_program_page',
        pageTitle: 'Event Reminders Edit',
        screenName: 'Event Reminders - Blooming Health'
    },
    programHistory: {
        eventName: 'program_history_list_page',
        pageTitle: 'Reminder History',
        screenName: 'Event Reminders History - Blooming Health'
    },
    selectSpecificIndividualReceipents: {
        eventName: 'select_specific_individual_receipents_page',
        pageTitle: 'Select Specific Individual Receipents',
        screenName: 'Broadcast - Blooming Health'
    },
    individualUsersSelectedMembers: {
        eventName: 'individual_users_selected_members_page',
        pageTitle: 'Individual Users Selected Members',
        screenName: 'Broadcast - Blooming Health'
    },
    referralManagement: {
        eventName: 'referral_management_list_page',
        pageTitle: 'Referral Management',
        screenName: 'Referral Management - Blooming Health'
    },
    registerReferral: {
        eventName: 'register_referral_page',
        pageTitle: 'Referral Management Register',
        screenName: 'Referral Management - Blooming Health'
    },
    createReferral: {
        eventName: 'create_referral_page',
        pageTitle: 'Referral Management Create',
        screenName: 'Referral Management - Blooming Health'
    },
    referralDetail: {
        eventName: 'referral_detail_page',
        pageTitle: 'Referral Management',
        screenName: 'Referral Management - Blooming Health'
    },
    workflowList : {
        eventName : 'workflow_list_page',
        pageTitle : 'Workflow List Page',
        screenName : 'Workflow - Blooming Health'
    },
    archivedWorkflowList : {
        eventName : 'archived_workflow_list_page',
        pageTitle : 'Archived Workflow List Page',
        screenName : 'Workflow - Blooming Health'
    },
    workflowVersion: {
        eventName : 'create_workflow_version_page',
        pageTitle : 'Create Workflow version Page',
        screenName : 'Workflow - Blooming Health'
    }
};

export const DUPLICATE_COMMS_DIALOG = {
    dialogTitle: 'Multiple Communication Warning',
    dialogDescription:
        'In order to avoid sending too many communications to same audience on the same day, we recommend reviewing all items to determine if any can be sent on another day. You can still proceed with this action if desired. The communications identified are:',
    broadcastTableTitle: 'Broadcast',
    broadcastTableDescription: 'Carefully review the list of all sent or scheduled broadcasts for the date you have selected.',
    surveyTableTitle: 'Survey',
    surveyTableDescription: 'Carefully review the list of all sent or scheduled surveys for the date you have selected.',
    surveyIdTooltip: 'The ID’s start with S as prefix is Survey Id and R is Rerun Id.'
};

export const MFA_TOGGLE_MODAL_CONFIG = {
    title: 'Are you sure you want to disable Secure Login?',
    message: `Disabling MFA removes an extra layer of security, making your account more vulnerable. Are you sure you want to proceed? You can re-enable it anytime in settings.`,
    enableClose: true,
    actions: {
        cancel: 'NO, CANCEL',
        ok: 'YES, DISABLE'
    }
};

export enum TransferScenario {
    P2P = 'p2p',
    O2P = 'o2p',
    P2IC = 'p2ic',
    P2L = 'p2l',
    P2O = 'p2o'
}

export enum TransferDestination {
    NO_PROGRAM = 'No Program',
    PROGRAM = 'program',
    INTEREST = 'interest',
    LABEL = 'label'
}

export enum AnalyticCategory {
    ProgramManagement = 'program_management'
}

export enum AnalyticAction {
    Input = 'input',
    SelectTimezone = 'select_timezone',
    UpdateField = 'update_field',
    SaveField = 'save_field',
    SelectServiceType = 'select_service_type',
    ViewProgramDetails = 'view_program_details',
    ViewCreationForm = 'view_creation_form',
    ShowPrompt = 'show_prompt',
    CancelAction = 'cancel_action',
    ConfirmArchive = 'confirm_archive',
    SearchUsers = 'search_users',
    ApplyFilter = 'apply_filter',
    AddUsers = 'add_users',
    RemoveUsers = 'remove_users',
    TransferUsers = 'transfer_users',
}


export const ORG_GA = {
    DRAWER: {
        STATE: {
            OPENED: 'opened',
            CLOSED: 'closed'
        }
    },

    TABS: {
        DETAILS: 'organization_details'
    },

    FILE_UPLOAD: {
        ERROR_REASON: {
            INVALID_TYPE: 'invalid_file_type',
            FILE_TOO_LARGE: 'file_size_exceeded'
        }
    },

    FORM_FIELDS: {
        ORGANIZATION_NAME: 'org_name',
        ORGANIZATION_CODE: 'org_code',
        PRIMARY_EMAIL: 'primary_email',
        PRIMARY_PHONE: 'primary_phone',
        WEBSITE_URL: 'website_url',
        TIMEZONE: 'timezone',
        ADDRESS_1: 'address1',
        ADDRESS_2: 'address2',
        CITY: 'city',
        STATE: 'state',
        STATE_CODE: 'state_code',
        ZIP: 'zip_code',
        MAP_LINK: 'map_link',
        DIRECTORY_FLAG: 'use_for_directory'
    },

    VALIDATION_ERROR: {
        REQUIRED: 'required',
        MAX_LENGTH: 'maxlength',
        PATTERN: 'pattern'
    },

    ADDRESS_FIELDS: [
        'addressLine1',
        'addressLine2',
        'city',
        'state',
        'stateCode',
        'zipCode',
        'mapLink',
        'useAddressForDirectory'
    ] as const

} as const;


export type OrgAddressField = typeof ORG_GA.ADDRESS_FIELDS[number];

export const CUSTOM_FIELD_GA = {
    DRAWER: {
        STATE: {
            OPENED: 'opened',
            CLOSED: 'closed'
        }
    },

    FIELD_TYPE: {
        SINGLE_SELECT: 'singleselect',
        MULTI_SELECT: 'multiselect'
    },

    STATUS: {
        ACTIVE: 'active',
        ARCHIVED: 'archived'
    }
} as const;

export const PROGRAM_FORM_FIELDS = {
    PROGRAM_NAME: 'program_name',
    POC_PHONE: 'redirect_phone_number',
    POC_NAME: 'program_lead',
    REPLY_EMAIL: 'reply_email',
    TIMEZONE: 'timezone',
    SERVICE_TYPE: 'service_type',
    ZIPCODE: 'zip_code',
} as const;

export const GA_FIELD_NAMES: Record<string, string> = {
    [PROGRAM_FORM_FIELDS.PROGRAM_NAME]: 'program_name',
    [PROGRAM_FORM_FIELDS.POC_PHONE]: 'poc_phone',
    [PROGRAM_FORM_FIELDS.POC_NAME]: 'poc_name',
    [PROGRAM_FORM_FIELDS.REPLY_EMAIL]: 'reply_email',
    [PROGRAM_FORM_FIELDS.TIMEZONE]: 'timezone',
    [PROGRAM_FORM_FIELDS.SERVICE_TYPE]: 'service_type',
    [PROGRAM_FORM_FIELDS.ZIPCODE]: 'zipcode',
};

export const HISTORY_AUDIT_LOGS_GA = {
    DRAWER: {
        STATE: {
            OPENED: 'opened',
            CLOSED: 'closed'
        }
    },
    DROPDOWN: {
        STATE: {
            OPENED: 'opened',
            CLOSED: 'closed'
        }
    }
}